var _regeneratorRuntime = require("/usr/src/guest-inbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

!function (e, t) {
  for (var n in t) {
    e[n] = t[n];
  }
}(exports, function (e) {
  var t = {};

  function n(r) {
    if (t[r]) return t[r].exports;
    var i = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var i in e) {
      n.d(r, i, function (t) {
        return e[t];
      }.bind(null, i));
    }
    return r;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 61);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t) {
  e.exports = require("@material-ui/core");
}, function (e, t) {
  e.exports = require("lodash");
}, function (e, t, n) {
  "use strict";

  e.exports = function (e) {
    var t = [];
    return t.toString = function () {
      return this.map(function (t) {
        var n = function (e, t) {
          var n = e[1] || "",
              r = e[3];
          if (!r) return n;

          if (t && "function" == typeof btoa) {
            var i = (a = r, s = btoa(unescape(encodeURIComponent(JSON.stringify(a)))), l = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(s), "/*# ".concat(l, " */")),
                o = r.sources.map(function (e) {
              return "/*# sourceURL=".concat(r.sourceRoot || "").concat(e, " */");
            });
            return [n].concat(o).concat([i]).join("\n");
          }

          var a, s, l;
          return [n].join("\n");
        }(t, e);

        return t[2] ? "@media ".concat(t[2], " {").concat(n, "}") : n;
      }).join("");
    }, t.i = function (e, n, r) {
      "string" == typeof e && (e = [[null, e, ""]]);
      var i = {};
      if (r) for (var o = 0; o < this.length; o++) {
        var a = this[o][0];
        null != a && (i[a] = !0);
      }

      for (var s = 0; s < e.length; s++) {
        var l = [].concat(e[s]);
        r && i[l[0]] || (n && (l[2] ? l[2] = "".concat(n, " and ").concat(l[2]) : l[2] = n), t.push(l));
      }
    }, t;
  };
}, function (e, t) {
  e.exports = require("prop-types");
}, function (e, t, n) {
  "use strict";

  var r,
      i = function i() {
    return void 0 === r && (r = Boolean(window && document && document.all && !window.atob)), r;
  },
      o = function () {
    var e = {};
    return function (t) {
      if (void 0 === e[t]) {
        var n = document.querySelector(t);
        if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
          n = n.contentDocument.head;
        } catch (e) {
          n = null;
        }
        e[t] = n;
      }

      return e[t];
    };
  }(),
      a = [];

  function s(e) {
    for (var t = -1, n = 0; n < a.length; n++) {
      if (a[n].identifier === e) {
        t = n;
        break;
      }
    }

    return t;
  }

  function l(e, t) {
    for (var n = {}, r = [], i = 0; i < e.length; i++) {
      var o = e[i],
          l = t.base ? o[0] + t.base : o[0],
          c = n[l] || 0,
          u = "".concat(l, " ").concat(c);
      n[l] = c + 1;
      var A = s(u),
          m = {
        css: o[1],
        media: o[2],
        sourceMap: o[3]
      };
      -1 !== A ? (a[A].references++, a[A].updater(m)) : a.push({
        identifier: u,
        updater: g(m, t),
        references: 1
      }), r.push(u);
    }

    return r;
  }

  function c(e) {
    var t = document.createElement("style"),
        r = e.attributes || {};

    if (void 0 === r.nonce) {
      var i = n.nc;
      i && (r.nonce = i);
    }

    if (Object.keys(r).forEach(function (e) {
      t.setAttribute(e, r[e]);
    }), "function" == typeof e.insert) e.insert(t);else {
      var a = o(e.insert || "head");
      if (!a) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
      a.appendChild(t);
    }
    return t;
  }

  var u,
      A = (u = [], function (e, t) {
    return u[e] = t, u.filter(Boolean).join("\n");
  });

  function m(e, t, n, r) {
    var i = n ? "" : r.media ? "@media ".concat(r.media, " {").concat(r.css, "}") : r.css;
    if (e.styleSheet) e.styleSheet.cssText = A(t, i);else {
      var o = document.createTextNode(i),
          a = e.childNodes;
      a[t] && e.removeChild(a[t]), a.length ? e.insertBefore(o, a[t]) : e.appendChild(o);
    }
  }

  function p(e, t, n) {
    var r = n.css,
        i = n.media,
        o = n.sourceMap;
    if (i ? e.setAttribute("media", i) : e.removeAttribute("media"), o && "undefined" != typeof btoa && (r += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(o)))), " */")), e.styleSheet) e.styleSheet.cssText = r;else {
      for (; e.firstChild;) {
        e.removeChild(e.firstChild);
      }

      e.appendChild(document.createTextNode(r));
    }
  }

  var f = null,
      d = 0;

  function g(e, t) {
    var n, r, i;

    if (t.singleton) {
      var o = d++;
      n = f || (f = c(t)), r = m.bind(null, n, o, !1), i = m.bind(null, n, o, !0);
    } else n = c(t), r = p.bind(null, n, t), i = function i() {
      !function (e) {
        if (null === e.parentNode) return !1;
        e.parentNode.removeChild(e);
      }(n);
    };

    return r(e), function (t) {
      if (t) {
        if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
        r(e = t);
      } else i();
    };
  }

  e.exports = function (e, t) {
    (t = t || {}).singleton || "boolean" == typeof t.singleton || (t.singleton = i());
    var n = l(e = e || [], t);
    return function (e) {
      if (e = e || [], "[object Array]" === Object.prototype.toString.call(e)) {
        for (var r = 0; r < n.length; r++) {
          var i = s(n[r]);
          a[i].references--;
        }

        for (var o = l(e, t), c = 0; c < n.length; c++) {
          var u = s(n[c]);
          0 === a[u].references && (a[u].updater(), a.splice(u, 1));
        }

        n = o;
      }
    };
  };
}, function (e, t) {
  e.exports = require("@material-ui/icons/Warning");
}, function (e, t) {
  e.exports = require("@material-ui/icons/Close");
}, function (e, t) {
  e.exports = require("moment-timezone");
}, function (e, t) {
  e.exports = require("@material-ui/icons/Event");
}, function (e, t, n) {
  "use strict";

  (function (e) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = function (t) {
      try {
        (void 0 !== e && e.env && e.env.DEBUG && e.env.DEBUG.match(/json-rules-engine/) || "undefined" != typeof window && window.localStorage && window.localStorage.debug && window.localStorage.debug.match(/json-rules-engine/)) && console.log(t);
      } catch (e) {}
    };
  }).call(this, n(34));
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var r,
      i = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, n, r) {
      return n && e(t.prototype, n), r && e(t, r), t;
    };
  }(),
      o = n(32),
      a = (r = o) && r.__esModule ? r : {
    default: r
  };

  var s = function () {
    function e(t, n, r) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.id = t;
      var i = {
        cache: !0
      };
      if (void 0 === r && (r = i), "function" != typeof n ? (this.value = n, this.type = this.constructor.CONSTANT) : (this.calculationMethod = n, this.type = this.constructor.DYNAMIC), !this.id) throw new Error("factId required");
      if (void 0 === this.value && void 0 === this.calculationMethod) throw new Error("facts must have a value or method");
      return this.priority = parseInt(r.priority || 1, 10), this.options = Object.assign({}, i, r), this.cacheKeyMethod = this.defaultCacheKeys, this;
    }

    return i(e, [{
      key: "isConstant",
      value: function value() {
        return this.type === this.constructor.CONSTANT;
      }
    }, {
      key: "isDynamic",
      value: function value() {
        return this.type === this.constructor.DYNAMIC;
      }
    }, {
      key: "calculate",
      value: function value(e, t) {
        return Object.prototype.hasOwnProperty.call(this, "value") ? this.value : this.calculationMethod(e, t);
      }
    }, {
      key: "defaultCacheKeys",
      value: function value(e, t) {
        return {
          params: t,
          id: e
        };
      }
    }, {
      key: "getCacheKey",
      value: function value(t) {
        if (!0 === this.options.cache) {
          var n = this.cacheKeyMethod(this.id, t);
          return e.hashFromObject(n);
        }
      }
    }], [{
      key: "hashFromObject",
      value: function value(e) {
        return (0, a.default)(e);
      }
    }]), e;
  }();

  s.CONSTANT = "CONSTANT", s.DYNAMIC = "DYNAMIC", t.default = s;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var r = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, n, r) {
      return n && e(t.prototype, n), r && e(t, r), t;
    };
  }();

  var i = function () {
    function e(t, n, r) {
      if (function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.name = String(t), !t) throw new Error("Missing operator name");
      if ("function" != typeof n) throw new Error("Missing operator callback");
      this.cb = n, this.factValueValidator = r, this.factValueValidator || (this.factValueValidator = function () {
        return !0;
      });
    }

    return r(e, [{
      key: "evaluate",
      value: function value(e, t) {
        return this.factValueValidator(e) && this.cb(e, t);
      }
    }]), e;
  }();

  t.default = i;
}, function (e, t) {
  e.exports = require("@material-ui/icons/Assignment");
}, function (e, t) {
  e.exports = require("@material-ui/icons/AssignmentTurnedIn");
}, function (e, t) {
  e.exports = require("@material-ui/icons/Cancel");
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var r = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, n, r) {
      return n && e(t.prototype, n), r && e(t, r), t;
    };
  }(),
      i = l(n(33)),
      o = l(n(35)),
      a = n(18),
      s = l(n(10));

  function l(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var c = function (e) {
    function t(e) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));

      "string" == typeof e && (e = JSON.parse(e)), e && e.conditions && n.setConditions(e.conditions), e && e.onSuccess && n.on("success", e.onSuccess), e && e.onFailure && n.on("failure", e.onFailure), e && (e.name || 0 === e.name) && n.setName(e.name);
      var r = e && e.priority || 1;
      n.setPriority(r);
      var i = e && e.event || {
        type: "unknown"
      };
      return n.setEvent(i), n;
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, e), r(t, [{
      key: "setPriority",
      value: function value(e) {
        if ((e = parseInt(e, 10)) <= 0) throw new Error("Priority must be greater than zero");
        return this.priority = e, this;
      }
    }, {
      key: "setName",
      value: function value(e) {
        if (!e && 0 !== e) throw new Error('Rule "name" must be defined');
        return this.name = e, this;
      }
    }, {
      key: "setConditions",
      value: function value(e) {
        if (!Object.prototype.hasOwnProperty.call(e, "all") && !Object.prototype.hasOwnProperty.call(e, "any")) throw new Error('"conditions" root must contain a single instance of "all" or "any"');
        return this.conditions = new i.default(e), this;
      }
    }, {
      key: "setEvent",
      value: function value(e) {
        if (!e) throw new Error("Rule: setEvent() requires event object");
        if (!Object.prototype.hasOwnProperty.call(e, "type")) throw new Error('Rule: setEvent() requires event object with "type" property');
        return this.event = {
          type: e.type
        }, e.params && (this.event.params = e.params), this;
      }
    }, {
      key: "setEngine",
      value: function value(e) {
        return this.engine = e, this;
      }
    }, {
      key: "toJSON",
      value: function value() {
        var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0],
            t = {
          conditions: this.conditions.toJSON(!1),
          priority: this.priority,
          event: this.event,
          name: this.name
        };
        return e ? JSON.stringify(t) : t;
      }
    }, {
      key: "prioritizeConditions",
      value: function value(e) {
        var t = this,
            n = e.reduce(function (e, n) {
          var r = n.priority;

          if (!r) {
            var i = t.engine.getFact(n.fact);
            r = i && i.priority || 1;
          }

          return e[r] || (e[r] = []), e[r].push(n), e;
        }, {});
        return Object.keys(n).sort(function (e, t) {
          return Number(e) > Number(t) ? -1 : 1;
        }).map(function (e) {
          return n[e];
        });
      }
    }, {
      key: "evaluate",
      value: function value(e) {
        var t = this,
            n = new o.default(this.conditions, this.event, this.priority, this.name),
            r = function r(n, _r) {
          return Array.isArray(n) || (n = [n]), Promise.all(n.map(function (n) {
            return function (n) {
              if (n.isBooleanOperator()) {
                var r = n[n.operator];
                return ("all" === n.operator ? l(r) : a(r)).then(function (e) {
                  var t = !0 === e;
                  return n.result = t, t;
                });
              }

              return n.evaluate(e, t.engine.operators).then(function (e) {
                var t = e.result;
                return n.factResult = e.leftHandSideValue, n.result = t, t;
              });
            }(n);
          })).then(function (e) {
            return (0, s.default)("rule::evaluateConditions results", e), _r.call(e, function (e) {
              return !0 === e;
            });
          });
        },
            i = function i(e, n) {
          if (0 === e.length) return Promise.resolve(!0);
          var i = Array.prototype.some;
          "all" === n && (i = Array.prototype.every);

          for (var o = t.prioritizeConditions(e), a = Promise.resolve(), l = function l(e) {
            var t = o[e],
                l = !1;
            a = a.then(function (e) {
              return "any" === n && !0 === e || l ? ((0, s.default)("prioritizeAndRun::detected truthy result; skipping remaining conditions"), l = !0, !0) : "all" === n && !1 === e || l ? ((0, s.default)("prioritizeAndRun::detected falsey result; skipping remaining conditions"), l = !0, !1) : r(t, i);
            });
          }, c = 0; c < o.length; c++) {
            l(c);
          }

          return a;
        },
            a = function a(e) {
          return i(e, "any");
        },
            l = function l(e) {
          return i(e, "all");
        },
            c = function c(r) {
          return n.setResult(r), r ? t.emit("success", n.event, e, n) : t.emit("failure", n.event, e, n), n;
        };

        return n.conditions.any ? a(n.conditions.any).then(function (e) {
          return c(e);
        }) : l(n.conditions.all).then(function (e) {
          return c(e);
        });
      }
    }]), t;
  }(a.EventEmitter);

  t.default = c;
}, function (e, t) {
  e.exports = require("lodash.isobjectlike");
}, function (e, t) {
  e.exports = require("events");
}, function (e, t, n) {
  "use strict";

  e.exports = n(30);
}, function (e, t) {
  e.exports = require("@material-ui/icons/StarBorder");
}, function (e, t) {
  e.exports = require("@material-ui/icons/StarRate");
}, function (e, t) {
  e.exports = require("@material-ui/icons/AccessTime");
}, function (e, t) {
  e.exports = require("moment");
}, function (e, t) {
  e.exports = require("@material-ui/icons/CheckCircleOutline");
}, function (e, t) {
  e.exports = require("@material-ui/icons/KeyboardBackspace");
}, function (e, t) {
  e.exports = require("@material-ui/icons/EventBusy");
}, function (e, t) {
  e.exports = require("@material-ui/icons/Launch");
}, function (e, t, n) {
  var r = n(5),
      i = n(29);
  "string" == typeof (i = i.__esModule ? i.default : i) && (i = [[e.i, i, ""]]);
  var o = {
    insert: "head",
    singleton: !1
  };
  r(i, o);
  e.exports = i.locals || {};
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var r = n(3),
      i = n.n(r)()(!0);
  i.push([e.i, ".messaging-form{position:relative;border:1px solid #ddd;font-family:Roboto,sans-serif;background:#fff;border-radius:4px;overflow:hidden}.messaging-form.closed{padding:10px}.messaging-form.closed.openable{cursor:pointer}.messaging-form.closed .icon-and-text{display:flex;align-items:center}.messaging-form.closed .time-estimate-or-completed-at{display:flex;justify-content:center}.messaging-form.closed .MuiSvgIcon-root{color:#00b18f;font-size:48px;margin-right:10px}.messaging-form.closed .main-line{font-size:14px;margin-bottom:10px}.messaging-form.closed .sub-line{font-size:11px;font-weight:300}.messaging-form.closed .estimated-time{background:#eee;padding:5px 20px;border-radius:6px;border:1px solid #ddd;display:inline-flex;align-items:center;justify-content:center;font-size:11px;color:#333;font-weight:400;margin-top:10px}.messaging-form.closed .estimated-time .MuiSvgIcon-root{color:#555;font-size:16px;margin-right:3px}.messaging-form .messaging-form-inner{padding:10px 20px}.messaging-form.fullscreen{max-width:720px;z-index:10000;position:fixed;width:100%;height:100%;top:0;left:50%;transform:translateX(-50%)}.messaging-form.fullscreen .messaging-form-inner{position:relative;padding:0}.messaging-form.fullscreen .messaging-form-inner .edit-overlay{position:absolute;background:rgba(0,0,0,.5);top:0;left:0;width:100%;height:calc(100% + 50px)}.messaging-form.fullscreen .messaging-form-inner .edit-overlay .confirm-edit-dialog{position:absolute;left:50%;top:50%;transform:translate(-50%, -50%);background:#fff;border:1px solid #ddd;padding:10px 20px;box-shadow:5px 5px 20px rgba(0,0,0,.2)}.messaging-form.fullscreen .messaging-form-inner .edit-overlay .confirm-edit-dialog .main-line{font-size:15px;margin-top:10px;display:flex;align-items:center;white-space:nowrap;font-weight:500}.messaging-form.fullscreen .messaging-form-inner .edit-overlay .confirm-edit-dialog .main-line .MuiSvgIcon-root{margin-right:10px}.messaging-form.fullscreen .messaging-form-inner .edit-overlay .confirm-edit-dialog .sub-line{white-space:nowrap;margin:30px 0;font-size:12px}.messaging-form.fullscreen .messaging-form-inner .edit-overlay .confirm-edit-dialog .actions{margin-top:10px}.messaging-form.fullscreen .messaging-form-inner .edit-overlay .confirm-edit-dialog .actions .cancel-button{margin-right:10px}.messaging-form.fullscreen .messaging-form-inner .title{padding:10px;height:30px;border-bottom:1px solid #ddd;margin-bottom:0}.messaging-form.fullscreen .messaging-form-inner .title .icon-and-title{display:flex;align-items:center}.messaging-form.fullscreen .messaging-form-inner .title .icon-and-title .MuiSvgIcon-root{margin-right:5px}.messaging-form.fullscreen .main-content{max-width:720px}.messaging-form.fullscreen .main-content.sending .questions{opacity:.3}.messaging-form.fullscreen .main-content .sending-progress{position:fixed;left:50%;top:50%;transform:translate(-50%, -50%)}.messaging-form.fullscreen .main-content .questions-wrapper{overflow-y:scroll;background:#fafafa}.messaging-form.fullscreen .main-content .fullscreen-question-wrapper{position:relative;box-sizing:border-box;padding:20px 15px 20px 15px;border-bottom:1px solid #ddd;border-left:5px solid transparent;background:#fff}.messaging-form.fullscreen .main-content .fullscreen-question-wrapper .left-bar{width:5px;height:100%;background:transparent;position:absolute;left:-5px;top:0;opacity:0;transition:opacity .3s}.messaging-form.fullscreen .main-content .fullscreen-question-wrapper.done .left-bar{opacity:1}.messaging-form.fullscreen .main-content .done-action{position:fixed;bottom:0;max-width:710px;width:calc(100% - 10px);padding:5px;background:#fff;border-top:1px solid #ddd;display:flex;justify-content:center}.messaging-form.fullscreen .main-content .done-action .send-button{max-width:400px}.messaging-form.fullscreen .main-content .done-action .send-button.MuiButton-containedPrimary{background-color:#1a84ff}.messaging-form.fullscreen .main-content .done-action .send-button.Mui-disabled{background-color:rgba(0,0,0,.1)}.messaging-form .title{font-size:17px;font-weight:500;margin-bottom:10px;height:35px;display:flex;align-items:center;justify-content:space-between}.messaging-form .main-content{height:calc(100% - 80px);display:flex;flex-direction:column}.messaging-form .pre-prompt{font-size:13px;line-height:1.4em}.messaging-form .prompt{font-size:13px;margin:10px 0;line-height:1.4em}.messaging-form .question-wrapper{transition:opacity .3s;opacity:0}.messaging-form .done-message{display:flex;align-items:center;flex-direction:row;justify-content:center;transition:opacity .3s;margin-bottom:10px}.messaging-form .done-message .MuiCircularProgress-root{color:#1a84ff}.messaging-form .done-message .MuiSvgIcon-root{color:#22bb5b;font-size:48px;margin-right:10px}.messaging-form .done-message .main-line{font-size:14px;margin-bottom:5px}.messaging-form .done-message .sub-line{font-size:11px;font-weight:300}.messaging-form .actions{display:flex;justify-content:flex-end;height:35px}.messaging-form .actions .previous-button{margin-right:10px}.messaging-form .actions .next-button{background:#1a84ff}.messaging-form .actions .next-button.Mui-disabled{background:rgba(0,0,0,.12)}", "", {
    version: 3,
    sources: ["webpack://lib/FullScreenStackedForm.sass"],
    names: [],
    mappings: "AAAA,gBACI,iBAAA,CACA,qBAAA,CACA,6BAAA,CACA,eAAA,CACA,iBAAA,CACA,eAAA,CAEA,uBACI,YAAA,CAEA,gCACI,cAAA,CAEJ,sCACI,YAAA,CACA,kBAAA,CAEJ,sDACI,YAAA,CACA,sBAAA,CAGJ,wCACI,aAAA,CACA,cAAA,CACA,iBAAA,CACJ,kCACI,cAAA,CACA,kBAAA,CACJ,iCACI,cAAA,CACA,eAAA,CACJ,uCACI,eAAA,CACA,gBAAA,CACA,iBAAA,CACA,qBAAA,CAEA,mBAAA,CACA,kBAAA,CACA,sBAAA,CACA,cAAA,CACA,UAAA,CACA,eAAA,CACA,eAAA,CAEA,wDACI,UAAA,CACA,cAAA,CACA,gBAAA,CAGZ,sCACI,iBAAA,CAEJ,2BACI,eAAA,CACA,aAAA,CACA,cAAA,CACA,UAAA,CACA,WAAA,CACA,KAAA,CACA,QAAA,CACA,0BAAA,CAEA,iDACI,iBAAA,CACA,SAAA,CAEA,+DACI,iBAAA,CACA,yBAAA,CACA,KAAA,CACA,MAAA,CACA,UAAA,CACA,wBAAA,CAEA,oFACI,iBAAA,CACA,QAAA,CACA,OAAA,CACA,+BAAA,CACA,eAAA,CACA,qBAAA,CACA,iBAAA,CACA,sCAAA,CAEA,+FACI,cAAA,CACA,eAAA,CACA,YAAA,CACA,kBAAA,CACA,kBAAA,CACA,eAAA,CACA,gHACI,iBAAA,CACR,8FACI,kBAAA,CACA,aAAA,CACA,cAAA,CACJ,6FACI,eAAA,CAEA,4GACI,iBAAA,CAEhB,wDACI,YAAA,CACA,WAAA,CACA,4BAAA,CACA,eAAA,CAEA,wEACI,YAAA,CACA,kBAAA,CAEA,yFACI,gBAAA,CAEhB,yCACI,eAAA,CAEI,4DACI,UAAA,CAER,2DACI,cAAA,CACA,QAAA,CACA,OAAA,CACA,+BAAA,CAEJ,4DACI,iBAAA,CACA,kBAAA,CACJ,sEACI,iBAAA,CACA,qBAAA,CACA,2BAAA,CACA,4BAAA,CACA,iCAAA,CACA,eAAA,CAEA,gFACI,SAAA,CACA,WAAA,CACA,sBAAA,CACA,iBAAA,CACA,SAAA,CACA,KAAA,CACA,SAAA,CACA,sBAAA,CAGA,qFACI,SAAA,CAEZ,sDACI,cAAA,CACA,QAAA,CACA,eAAA,CACA,uBAAA,CACA,WAAA,CACA,eAAA,CACA,yBAAA,CACA,YAAA,CACA,sBAAA,CAEA,mEAEI,eAAA,CACA,8FACI,wBAAA,CAEJ,gFACI,+BAAA,CAMpB,uBACI,cAAA,CACA,eAAA,CACA,kBAAA,CACA,WAAA,CACA,YAAA,CACA,kBAAA,CACA,6BAAA,CAEJ,8BACI,wBAAA,CACA,YAAA,CACA,qBAAA,CAEJ,4BACI,cAAA,CACA,iBAAA,CAEJ,wBACI,cAAA,CACA,aAAA,CACA,iBAAA,CAEJ,kCACI,sBAAA,CACA,SAAA,CAEJ,8BACI,YAAA,CACA,kBAAA,CACA,kBAAA,CACA,sBAAA,CACA,sBAAA,CACA,kBAAA,CAEA,wDACI,aAAA,CAEJ,+CACI,aAAA,CACA,cAAA,CACA,iBAAA,CAEJ,yCACI,cAAA,CACA,iBAAA,CACJ,wCACI,cAAA,CACA,eAAA,CAER,yBACI,YAAA,CACA,wBAAA,CACA,WAAA,CAEA,0CACI,iBAAA,CAEJ,sCACI,kBAAA,CACA,mDACI,0BAAA",
    sourcesContent: [".messaging-form \n    position: relative\n    border: 1px solid #ddd\n    font-family: Roboto, sans-serif\n    background: #fff\n    border-radius: 4px\n    overflow: hidden\n    \n    &.closed\n        padding: 10px\n\n        &.openable\n            cursor: pointer\n        \n        .icon-and-text\n            display: flex\n            align-items: center\n        \n        .time-estimate-or-completed-at\n            display: flex\n            justify-content: center\n            \n        \n        .MuiSvgIcon-root\n            color: #00B18F\n            font-size: 48px\n            margin-right: 10px\n        .main-line\n            font-size: 14px\n            margin-bottom: 10px\n        .sub-line\n            font-size: 11px\n            font-weight: 300\n        .estimated-time\n            background: #eee\n            padding: 5px 20px\n            border-radius: 6px\n            border: 1px solid #ddd\n            //box-shadow: 2px 2px 3px rgba(0,0,0,0.2)\n            display: inline-flex\n            align-items: center\n            justify-content: center\n            font-size: 11px\n            color: #333\n            font-weight: 400\n            margin-top: 10px\n            \n            .MuiSvgIcon-root\n                color: #555\n                font-size: 16px\n                margin-right: 3px\n                        \n    \n    .messaging-form-inner\n        padding: 10px 20px\n    \n    &.fullscreen\n        max-width: 720px\n        z-index: 10000\n        position: fixed\n        width: 100%\n        height: 100%\n        top: 0\n        left:50%\n        transform: translateX(-50%)\n        \n        .messaging-form-inner\n            position: relative\n            padding: 0\n            \n            .edit-overlay\n                position: absolute\n                background: rgba(0,0,0,0.5)\n                top: 0\n                left: 0\n                width: 100%\n                height: calc(100% + 50px)\n                \n                .confirm-edit-dialog\n                    position: absolute\n                    left: 50%\n                    top: 50%\n                    transform: translate(-50%, -50%)\n                    background: #ffffff\n                    border: 1px solid #dddddd\n                    padding: 10px 20px\n                    box-shadow: 5px 5px 20px rgba(0,0,0,0.2)                    \n                    \n                    .main-line\n                        font-size: 15px\n                        margin-top: 10px\n                        display: flex\n                        align-items: center\n                        white-space: nowrap\n                        font-weight: 500\n                        .MuiSvgIcon-root\n                            margin-right: 10px\n                    .sub-line\n                        white-space: nowrap\n                        margin: 30px 0\n                        font-size: 12px\n                    .actions\n                        margin-top: 10px\n                        \n                        .cancel-button\n                            margin-right: 10px\n            \n            .title\n                padding: 10px\n                height: 30px\n                border-bottom: 1px solid #ddd\n                margin-bottom: 0\n                \n                .icon-and-title\n                    display: flex\n                    align-items: center\n                    \n                    .MuiSvgIcon-root\n                        margin-right: 5px\n        \n        .main-content\n            max-width: 720px\n            &.sending\n                .questions\n                    opacity: 0.3\n        \n            .sending-progress\n                position: fixed\n                left: 50%\n                top: 50%\n                transform: translate(-50%, -50%)\n        \n            .questions-wrapper\n                overflow-y: scroll\n                background: #fafafa\n            .fullscreen-question-wrapper\n                position: relative\n                box-sizing: border-box\n                padding: 20px 15px 20px 15px\n                border-bottom: 1px solid #ddd\n                border-left: 5px solid transparent\n                background: #fff\n                \n                .left-bar\n                    width: 5px\n                    height: 100%\n                    background: transparent\n                    position: absolute\n                    left: -5px\n                    top: 0\n                    opacity: 0\n                    transition: opacity 0.3s\n                    \n                &.done\n                    .left-bar\n                        opacity: 1\n                        \n            .done-action\n                position: fixed\n                bottom: 0\n                max-width: 710px\n                width: calc(100% - 10px)\n                padding: 5px\n                background: #ffffff\n                border-top: 1px solid #ddd\n                display: flex\n                justify-content: center\n                \n                .send-button\n                    //background-color: #1A84FF\n                    max-width: 400px\n                    &.MuiButton-containedPrimary\n                        background-color: #1A84FF\n                        \n                    &.Mui-disabled\n                        background-color: rgba(0,0,0,0.1)\n                        \n                \n        \n    \n    \n    .title\n        font-size: 17px\n        font-weight: 500\n        margin-bottom: 10px\n        height: 35px\n        display: flex\n        align-items: center\n        justify-content: space-between\n                \n    .main-content\n        height: calc(100% - 80px)\n        display: flex\n        flex-direction: column\n        \n    .pre-prompt\n        font-size: 13px\n        line-height: 1.4em\n        \n    .prompt\n        font-size: 13px\n        margin: 10px 0\n        line-height: 1.4em\n        \n    .question-wrapper\n        transition: opacity 0.3s\n        opacity: 0\n        \n    .done-message\n        display: flex\n        align-items: center\n        flex-direction: row\n        justify-content: center\n        transition: opacity 0.3s\n        margin-bottom: 10px\n        \n        .MuiCircularProgress-root\n            color: #1A84FF\n        \n        .MuiSvgIcon-root\n            color: #22bb5b\n            font-size: 48px\n            margin-right: 10px\n            \n        .main-line\n            font-size: 14px\n            margin-bottom: 5px\n        .sub-line\n            font-size: 11px\n            font-weight: 300\n        \n    .actions\n        display: flex\n        justify-content: flex-end\n        height: 35px\n        \n        .previous-button\n            margin-right: 10px\n        \n        .next-button\n            background: #1A84FF\n            &.Mui-disabled\n                background: rgba(0,0,0,0.12)\n    \n"],
    sourceRoot: ""
  }]), t.default = i;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.Engine = t.Operator = t.Rule = t.Fact = void 0, t.default = function (e, t) {
    return new r.default(e, t);
  };
  var r = s(n(31)),
      i = s(n(11)),
      o = s(n(16)),
      a = s(n(12));

  function s(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  t.Fact = i.default, t.Rule = o.default, t.Operator = a.default, t.Engine = r.default;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.FINISHED = t.RUNNING = t.READY = void 0;

  var r = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, n, r) {
      return n && e(t.prototype, n), r && e(t, r), t;
    };
  }(),
      i = m(n(11)),
      o = m(n(16)),
      a = m(n(12)),
      s = m(n(37)),
      l = n(18),
      c = n(40),
      u = m(n(41)),
      A = m(n(10));

  function m(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function p(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function f(e, t) {
    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !t || "object" != typeof t && "function" != typeof t ? e : t;
  }

  var d = t.READY = "READY",
      g = t.RUNNING = "RUNNING",
      h = t.FINISHED = "FINISHED",
      C = function (e) {
    function t() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
          n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      p(this, t);
      var r = f(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
      return r.rules = [], r.allowUndefinedFacts = n.allowUndefinedFacts || !1, r.operators = new Map(), r.facts = new Map(), r.status = d, e.map(function (e) {
        return r.addRule(e);
      }), u.default.map(function (e) {
        return r.addOperator(e);
      }), r;
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, e), r(t, [{
      key: "addRule",
      value: function value(e) {
        if (!e) throw new Error("Engine: addRule() requires options");
        if (!Object.prototype.hasOwnProperty.call(e, "conditions")) throw new Error('Engine: addRule() argument requires "conditions" property');
        if (!Object.prototype.hasOwnProperty.call(e, "event")) throw new Error('Engine: addRule() argument requires "event" property');
        var t = void 0;
        return (t = e instanceof o.default ? e : new o.default(e)).setEngine(this), this.rules.push(t), this.prioritizedRules = null, this;
      }
    }, {
      key: "removeRule",
      value: function value(e) {
        if (e instanceof o.default == !1) throw new Error("Engine: removeRule() rule must be a instance of Rule");
        var t = this.rules.indexOf(e);
        return -1 !== t && (this.prioritizedRules = null, Boolean(this.rules.splice(t, 1).length));
      }
    }, {
      key: "addOperator",
      value: function value(e, t) {
        var n = void 0;
        n = e instanceof a.default ? e : new a.default(e, t), (0, A.default)("engine::addOperator name:" + n.name), this.operators.set(n.name, n);
      }
    }, {
      key: "removeOperator",
      value: function value(e) {
        var t = void 0;
        return t = e instanceof a.default ? e.name : e, this.operators.delete(t);
      }
    }, {
      key: "addFact",
      value: function value(e, t, n) {
        var r = e,
            o = void 0;
        return e instanceof i.default ? (r = e.id, o = e) : o = new i.default(e, t, n), (0, A.default)("engine::addFact id:" + r), this.facts.set(r, o), this;
      }
    }, {
      key: "removeFact",
      value: function value(e) {
        var t = void 0;
        return t = e instanceof i.default ? e.id : e, this.facts.delete(t);
      }
    }, {
      key: "prioritizeRules",
      value: function value() {
        if (!this.prioritizedRules) {
          var e = this.rules.reduce(function (e, t) {
            var n = t.priority;
            return e[n] || (e[n] = []), e[n].push(t), e;
          }, {});
          this.prioritizedRules = Object.keys(e).sort(function (e, t) {
            return Number(e) > Number(t) ? -1 : 1;
          }).map(function (t) {
            return e[t];
          });
        }

        return this.prioritizedRules;
      }
    }, {
      key: "stop",
      value: function value() {
        return this.status = h, this;
      }
    }, {
      key: "getFact",
      value: function value(e) {
        return this.facts.get(e);
      }
    }, {
      key: "evaluateRules",
      value: function value(e, t) {
        var n = this;
        return Promise.all(e.map(function (e) {
          if (n.status === g) return e.evaluate(t).then(function (r) {
            (0, A.default)("engine::run ruleResult:" + r.result), r.result ? (n.emit("success", e.event, t, r), n.emit(e.event.type, e.event.params, t, r), t.factValue("success-events", {
              event: e.event
            })) : n.emit("failure", e.event, t, r);
          });
          (0, A.default)("engine::run status:" + n.status + "; skipping remaining rules");
        }));
      }
    }, {
      key: "run",
      value: function value() {
        var e = this,
            t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        (0, A.default)("engine::run started"), (0, A.default)("engine::run runtimeFacts:", t), t["success-events"] = new i.default("success-events", (0, c.SuccessEventFact)(), {
          cache: !1
        }), this.status = g;
        var n = new s.default(this.facts, t, {
          allowUndefinedFacts: this.allowUndefinedFacts
        }),
            r = this.prioritizeRules(),
            o = Promise.resolve();
        return new Promise(function (t, i) {
          r.map(function (t) {
            return o = o.then(function () {
              return e.evaluateRules(t, n);
            }).catch(i);
          }), o.then(function () {
            return e.status = h, (0, A.default)("engine::run completed"), n.factValue("success-events");
          }).then(function (e) {
            t({
              events: e,
              almanac: n
            });
          }).catch(i);
        });
      }
    }]), t;
  }(l.EventEmitter);

  t.default = C;
}, function (e, t) {
  e.exports = require("hash-it");
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var r = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, n, r) {
      return n && e(t.prototype, n), r && e(t, r), t;
    };
  }(),
      i = a(n(10)),
      o = a(n(17));

  function a(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var s = function () {
    function e(t) {
      if (function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), !t) throw new Error("Condition: constructor options required");
      var n = e.booleanOperator(t);

      if (Object.assign(this, t), n) {
        var r = t[n];
        if (!Array.isArray(r)) throw new Error('"' + n + '" must be an array');
        this.operator = n, this.priority = parseInt(t.priority, 10) || 1, this[n] = r.map(function (t) {
          return new e(t);
        });
      } else {
        if (!Object.prototype.hasOwnProperty.call(t, "fact")) throw new Error('Condition: constructor "fact" property required');
        if (!Object.prototype.hasOwnProperty.call(t, "operator")) throw new Error('Condition: constructor "operator" property required');
        if (!Object.prototype.hasOwnProperty.call(t, "value")) throw new Error('Condition: constructor "value" property required');
        Object.prototype.hasOwnProperty.call(t, "priority") && (t.priority = parseInt(t.priority, 10));
      }
    }

    return r(e, [{
      key: "toJSON",
      value: function value() {
        var t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0],
            n = {};
        this.priority && (n.priority = this.priority);
        var r = e.booleanOperator(this);
        return r ? n[r] = this[r].map(function (e) {
          return e.toJSON(t);
        }) : (n.operator = this.operator, n.value = this.value, n.fact = this.fact, void 0 !== this.factResult && (n.factResult = this.factResult), void 0 !== this.result && (n.result = this.result), this.params && (n.params = this.params), this.path && (n.path = this.path)), t ? JSON.stringify(n) : n;
      }
    }, {
      key: "_getValue",
      value: function value(e) {
        var t = this.value;
        return (0, o.default)(t) && Object.prototype.hasOwnProperty.call(t, "fact") ? e.factValue(t.fact, t.params, t.path) : Promise.resolve(t);
      }
    }, {
      key: "evaluate",
      value: function value(e, t) {
        var n = this;
        if (!e) return Promise.reject(new Error("almanac required"));
        if (!t) return Promise.reject(new Error("operatorMap required"));
        if (this.isBooleanOperator()) return Promise.reject(new Error("Cannot evaluate() a boolean condition"));
        var r = t.get(this.operator);
        return r ? this._getValue(e).then(function (t) {
          return e.factValue(n.fact, n.params, n.path).then(function (e) {
            var o = r.evaluate(e, t);
            return (0, i.default)("condition::evaluate <" + e + " " + n.operator + " " + t + "?> (" + o + ")"), {
              result: o,
              leftHandSideValue: e,
              rightHandSideValue: t,
              operator: n.operator
            };
          });
        }) : Promise.reject(new Error("Unknown operator: " + this.operator));
      }
    }, {
      key: "booleanOperator",
      value: function value() {
        return e.booleanOperator(this);
      }
    }, {
      key: "isBooleanOperator",
      value: function value() {
        return void 0 !== e.booleanOperator(this);
      }
    }], [{
      key: "booleanOperator",
      value: function value(e) {
        return Object.prototype.hasOwnProperty.call(e, "any") ? "any" : Object.prototype.hasOwnProperty.call(e, "all") ? "all" : void 0;
      }
    }]), e;
  }();

  t.default = s;
}, function (e, t) {
  var n,
      r,
      i = e.exports = {};

  function o() {
    throw new Error("setTimeout has not been defined");
  }

  function a() {
    throw new Error("clearTimeout has not been defined");
  }

  function s(e) {
    if (n === setTimeout) return setTimeout(e, 0);
    if ((n === o || !n) && setTimeout) return n = setTimeout, setTimeout(e, 0);

    try {
      return n(e, 0);
    } catch (t) {
      try {
        return n.call(null, e, 0);
      } catch (t) {
        return n.call(this, e, 0);
      }
    }
  }

  !function () {
    try {
      n = "function" == typeof setTimeout ? setTimeout : o;
    } catch (e) {
      n = o;
    }

    try {
      r = "function" == typeof clearTimeout ? clearTimeout : a;
    } catch (e) {
      r = a;
    }
  }();
  var l,
      c = [],
      u = !1,
      A = -1;

  function m() {
    u && l && (u = !1, l.length ? c = l.concat(c) : A = -1, c.length && p());
  }

  function p() {
    if (!u) {
      var e = s(m);
      u = !0;

      for (var t = c.length; t;) {
        for (l = c, c = []; ++A < t;) {
          l && l[A].run();
        }

        A = -1, t = c.length;
      }

      l = null, u = !1, function (e) {
        if (r === clearTimeout) return clearTimeout(e);
        if ((r === a || !r) && clearTimeout) return r = clearTimeout, clearTimeout(e);

        try {
          r(e);
        } catch (t) {
          try {
            return r.call(null, e);
          } catch (t) {
            return r.call(this, e);
          }
        }
      }(e);
    }
  }

  function f(e, t) {
    this.fun = e, this.array = t;
  }

  function d() {}

  i.nextTick = function (e) {
    var t = new Array(arguments.length - 1);
    if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
      t[n - 1] = arguments[n];
    }
    c.push(new f(e, t)), 1 !== c.length || u || s(p);
  }, f.prototype.run = function () {
    this.fun.apply(null, this.array);
  }, i.title = "browser", i.browser = !0, i.env = {}, i.argv = [], i.version = "", i.versions = {}, i.on = d, i.addListener = d, i.once = d, i.off = d, i.removeListener = d, i.removeAllListeners = d, i.emit = d, i.prependListener = d, i.prependOnceListener = d, i.listeners = function (e) {
    return [];
  }, i.binding = function (e) {
    throw new Error("process.binding is not supported");
  }, i.cwd = function () {
    return "/";
  }, i.chdir = function (e) {
    throw new Error("process.chdir is not supported");
  }, i.umask = function () {
    return 0;
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var r,
      i = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, n, r) {
      return n && e(t.prototype, n), r && e(t, r), t;
    };
  }(),
      o = n(36),
      a = (r = o) && r.__esModule ? r : {
    default: r
  };

  var s = function () {
    function e(t, n, r, i) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.conditions = (0, a.default)(t), this.event = (0, a.default)(n), this.priority = (0, a.default)(r), this.name = (0, a.default)(i), this.result = null;
    }

    return i(e, [{
      key: "setResult",
      value: function value(e) {
        this.result = e;
      }
    }, {
      key: "toJSON",
      value: function value() {
        var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0],
            t = {
          conditions: this.conditions.toJSON(!1),
          event: this.event,
          priority: this.priority,
          name: this.name,
          result: this.result
        };
        return e ? JSON.stringify(t) : t;
      }
    }]), e;
  }();

  t.default = s;
}, function (e, t) {
  e.exports = require("clone");
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
      i = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, n, r) {
      return n && e(t.prototype, n), r && e(t, r), t;
    };
  }(),
      o = u(n(11)),
      a = n(38),
      s = u(n(10)),
      l = n(39),
      c = u(n(17));

  function u(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function A(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  var m = function () {
    function e(t) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};

      for (var a in A(this, e), this.factMap = new Map(t), this.factResultsCache = new Map(), this.allowUndefinedFacts = Boolean(i.allowUndefinedFacts), n) {
        var l = void 0;
        l = n[a] instanceof o.default ? n[a] : new o.default(a, n[a]), this._addConstantFact(l), (0, s.default)("almanac::constructor initialized runtime fact:" + l.id + " with " + l.value + "<" + r(l.value) + ">");
      }
    }

    return i(e, [{
      key: "_getFact",
      value: function value(e) {
        return this.factMap.get(e);
      }
    }, {
      key: "_addConstantFact",
      value: function value(e) {
        this.factMap.set(e.id, e), this._setFactValue(e, {}, e.value);
      }
    }, {
      key: "_setFactValue",
      value: function value(e, t, n) {
        var r = e.getCacheKey(t),
            i = Promise.resolve(n);
        return r && this.factResultsCache.set(r, i), i;
      }
    }, {
      key: "addRuntimeFact",
      value: function value(e, t) {
        (0, s.default)("almanac::addRuntimeFact id:" + e);
        var n = new o.default(e, t);
        return this._addConstantFact(n);
      }
    }, {
      key: "factValue",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "",
            o = void 0,
            u = this._getFact(e);

        if (void 0 === u) return this.allowUndefinedFacts ? Promise.resolve(void 0) : Promise.reject(new a.UndefinedFactError("Undefined fact: " + e));
        if (u.isConstant()) o = Promise.resolve(u.calculate(t, this));else {
          var A = u.getCacheKey(t),
              m = A && this.factResultsCache.get(A);
          m ? (o = Promise.resolve(m), (0, s.default)("almanac::factValue cache hit for fact:" + e)) : ((0, s.default)("almanac::factValue cache miss for fact:" + e + "; calculating"), o = this._setFactValue(u, t, u.calculate(t, this)));
        }

        if (i) {
          if ("string" == typeof i && i.startsWith("$")) return (0, s.default)("condition::evaluate extracting object property " + i), o.then(function (e) {
            if ((0, c.default)(e)) {
              var t = (0, l.JSONPath)({
                path: i,
                json: e,
                wrap: !1
              });
              return (0, s.default)("condition::evaluate extracting object property " + i + ", received: " + t), t;
            }

            return (0, s.default)("condition::evaluate could not compute object path(" + i + ") of non-object: " + e + " <" + (void 0 === e ? "undefined" : r(e)) + ">; continuing with " + e), e;
          });
          var p = void 0;

          try {
            p = n(!function () {
              var e = new Error("Cannot find module 'selectn'");
              throw e.code = "MODULE_NOT_FOUND", e;
            }());
          } catch (e) {
            throw console.error('Oops! Looks like you\'re trying to use the deprecated syntax for the ".path" property.'), console.error('Please convert your "path" properties to JsonPath syntax (ensure your path starts with "$")'), console.error('Alternatively, if you wish to continue using old syntax (provided by selectn), you may "npm install selectn" as a direct dependency.'), console.error("See https://github.com/CacheControl/json-rules-engine/blob/master/CHANGELOG.md#500--2019-10-27 for more information."), new Error('json-rules-engine: Unmet peer dependency "selectn" required for use of deprecated ".path" syntax. please "npm install selectn" or convert to json-path syntax');
          }

          return o.then(function (e) {
            if ((0, c.default)(e)) {
              var t = p(i)(e);
              return (0, s.default)("condition::evaluate extracting object property " + i + ", received: " + t), t;
            }

            return (0, s.default)("condition::evaluate could not compute object path(" + i + ") of non-object: " + e + " <" + (void 0 === e ? "undefined" : r(e)) + ">; continuing with " + e), e;
          });
        }

        return o;
      }
    }]), e;
  }();

  t.default = m;
}, function (e, t, n) {
  "use strict";

  function r(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function i(e, t) {
    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !t || "object" != typeof t && "function" != typeof t ? e : t;
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  t.UndefinedFactError = function (e) {
    function t() {
      var e;
      r(this, t);

      for (var n = arguments.length, o = Array(n), a = 0; a < n; a++) {
        o[a] = arguments[a];
      }

      var s = i(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(o)));
      return s.code = "UNDEFINED_FACT", s;
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, Error), t;
  }();
}, function (e, t) {
  e.exports = require("jsonpath-plus");
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  t.SuccessEventFact = function () {
    var e = [];
    return function () {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      return t.event && e.push(t.event), e;
    };
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r,
      i = n(12),
      o = (r = i) && r.__esModule ? r : {
    default: r
  };
  var a = [];

  function s(e) {
    return "NaN" !== Number.parseFloat(e).toString();
  }

  a.push(new o.default("equal", function (e, t) {
    return e === t;
  })), a.push(new o.default("notEqual", function (e, t) {
    return e !== t;
  })), a.push(new o.default("in", function (e, t) {
    return t.indexOf(e) > -1;
  })), a.push(new o.default("notIn", function (e, t) {
    return -1 === t.indexOf(e);
  })), a.push(new o.default("contains", function (e, t) {
    return e.indexOf(t) > -1;
  }, Array.isArray)), a.push(new o.default("doesNotContain", function (e, t) {
    return -1 === e.indexOf(t);
  }, Array.isArray)), a.push(new o.default("lessThan", function (e, t) {
    return e < t;
  }, s)), a.push(new o.default("lessThanInclusive", function (e, t) {
    return e <= t;
  }, s)), a.push(new o.default("greaterThan", function (e, t) {
    return e > t;
  }, s)), a.push(new o.default("greaterThanInclusive", function (e, t) {
    return e >= t;
  }, s)), t.default = a;
}, function (e, t, n) {
  var r = n(5),
      i = n(43);
  "string" == typeof (i = i.__esModule ? i.default : i) && (i = [[e.i, i, ""]]);
  var o = {
    insert: "head",
    singleton: !1
  };
  r(i, o);
  e.exports = i.locals || {};
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var r = n(3),
      i = n.n(r)()(!0);
  i.push([e.i, ".checkbox-question .options{margin:10px 20px}.checkbox-question .options .MuiIconButton-root{padding:7px}.checkbox-question .options .MuiIconButton-root .MuiSvgIcon-root{font-size:20px}.checkbox-question .options .Mui-checked .MuiSvgIcon-root{color:#1a84ff}.checkbox-question .options .MuiFormControlLabel-label{font-size:13px}.checkbox-question .options .custom-value-textfield .MuiInput-input{font-size:13px}.checkbox-question .next-button{background:#1a84ff}.checkbox-question .next-button.Mui-disabled{background:rgba(0,0,0,.12)}", "", {
    version: 3,
    sources: ["webpack://lib/CheckboxQuestion.sass"],
    names: [],
    mappings: "AACI,4BACI,gBAAA,CACA,gDACI,WAAA,CACA,iEACI,cAAA,CAEJ,0DACI,aAAA,CACR,uDACI,cAAA,CAGA,oEACI,cAAA,CAEZ,gCACI,kBAAA,CACA,6CACI,0BAAA",
    sourcesContent: [".checkbox-question\n    .options\n        margin: 10px 20px\n        .MuiIconButton-root\n            padding: 7px\n            .MuiSvgIcon-root\n                font-size: 20px\n        .Mui-checked\n            .MuiSvgIcon-root\n                color: #1A84FF\n        .MuiFormControlLabel-label\n            font-size: 13px\n            \n        .custom-value-textfield\n            .MuiInput-input\n                font-size: 13px\n                \n    .next-button\n        background: #1A84FF\n        &.Mui-disabled\n            background: rgba(0,0,0,0.12)"],
    sourceRoot: ""
  }]), t.default = i;
}, function (e, t, n) {
  var r = n(5),
      i = n(45);
  "string" == typeof (i = i.__esModule ? i.default : i) && (i = [[e.i, i, ""]]);
  var o = {
    insert: "head",
    singleton: !1
  };
  r(i, o);
  e.exports = i.locals || {};
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var r = n(3),
      i = n.n(r)()(!0);
  i.push([e.i, ".free-text-question .MuiInputBase-input{font-size:13px}.free-text-question .actions{margin-top:10px}", "", {
    version: 3,
    sources: ["webpack://lib/FreeTextQuestion.sass"],
    names: [],
    mappings: "AACI,wCACI,cAAA,CAEJ,6BACI,eAAA",
    sourcesContent: [".free-text-question\n    .MuiInputBase-input\n        font-size: 13px\n        \n    .actions\n        margin-top: 10px"],
    sourceRoot: ""
  }]), t.default = i;
}, function (e, t, n) {
  var r = n(5),
      i = n(47);
  "string" == typeof (i = i.__esModule ? i.default : i) && (i = [[e.i, i, ""]]);
  var o = {
    insert: "head",
    singleton: !1
  };
  r(i, o);
  e.exports = i.locals || {};
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var r = n(3),
      i = n.n(r)()(!0);
  i.push([e.i, ".multiple-choice-question .option-buttons{margin:auto;max-width:400px;display:flex;flex-direction:column;align-content:center;justify-content:center}.multiple-choice-question .option-buttons .option-button{max-width:400px;margin:5px 0}.multiple-choice-question .option-buttons .option-button.MuiButton-containedPrimary{background-color:#00b18f}.multiple-choice-question .option-buttons .option-button.MuiButton-outlined{background-color:#d1f1eb;border:1px solid rgba(0,0,0,.05);color:#aaa}", "", {
    version: 3,
    sources: ["webpack://lib/MultipleChoiceQuestion.sass"],
    names: [],
    mappings: "AACI,0CACI,WAAA,CACA,eAAA,CACA,YAAA,CACA,qBAAA,CACA,oBAAA,CACA,sBAAA,CAEA,yDACI,eAAA,CACA,YAAA,CAEA,oFACI,wBAAA,CAEJ,4EACI,wBAAA,CACA,gCAAA,CACA,UAAA",
    sourcesContent: [".multiple-choice-question\n    .option-buttons\n        margin: auto\n        max-width: 400px\n        display: flex\n        flex-direction: column\n        align-content: center\n        justify-content: center\n        \n        .option-button\n            max-width: 400px\n            margin: 5px 0\n    \n            &.MuiButton-containedPrimary\n                background-color: #00B18F\n                \n            &.MuiButton-outlined\n                background-color: #D1F1EB\n                border: 1px solid rgba(0,0,0,0.05)\n                color: #aaa\n"],
    sourceRoot: ""
  }]), t.default = i;
}, function (e, t, n) {
  var r = n(5),
      i = n(49);
  "string" == typeof (i = i.__esModule ? i.default : i) && (i = [[e.i, i, ""]]);
  var o = {
    insert: "head",
    singleton: !1
  };
  r(i, o);
  e.exports = i.locals || {};
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var r = n(3),
      i = n.n(r)()(!0);
  i.push([e.i, ".five-star-rating-question .stars{display:flex;justify-content:center;margin-top:20px}.five-star-rating-question .stars .star-outline{font-size:42px;color:#888;cursor:pointer}.five-star-rating-question .stars .star-outline.selected{color:#555}.five-star-rating-question .stars .star-inner{font-size:38px;position:absolute;opacity:0;color:#ff0;transform:translate(calc(-100% - 2px), 3px);pointer-events:none;transition:opacity .25s}.five-star-rating-question .stars .star-inner.selected{opacity:.9}.five-star-rating-question .star-labels{width:200px;margin:auto;display:flex;justify-content:space-between}.five-star-rating-question .star-labels .label{font-size:10px;color:#888}", "", {
    version: 3,
    sources: ["webpack://lib/FiveStarRatingQuestion.sass"],
    names: [],
    mappings: "AACI,kCACI,YAAA,CACA,sBAAA,CACA,eAAA,CACA,gDACI,cAAA,CACA,UAAA,CACA,cAAA,CAEA,yDACI,UAAA,CAER,8CACI,cAAA,CACA,iBAAA,CACA,SAAA,CACA,UAAA,CACA,2CAAA,CACA,mBAAA,CACA,uBAAA,CAEA,uDACI,UAAA,CAEZ,wCACI,WAAA,CACA,WAAA,CACA,YAAA,CACA,6BAAA,CACA,+CACI,cAAA,CACA,UAAA",
    sourcesContent: [".five-star-rating-question\n    .stars\n        display: flex\n        justify-content: center\n        margin-top: 20px\n        .star-outline\n            font-size: 42px\n            color: #888\n            cursor: pointer\n            \n            &.selected\n                color: #555\n            \n        .star-inner\n            font-size: 38px\n            position: absolute\n            opacity: 0\n            color: yellow\n            transform: translate(calc(-100% - 2px), 3px)\n            pointer-events: none\n            transition: opacity 0.25s\n            \n            &.selected\n                opacity: 0.9\n                \n    .star-labels\n        width: 200px\n        margin: auto\n        display: flex\n        justify-content: space-between\n        .label\n            font-size: 10px\n            color: #888"],
    sourceRoot: ""
  }]), t.default = i;
}, function (e, t) {
  e.exports = require("@material-ui/icons/Star");
}, function (e, t, n) {
  var r = n(5),
      i = n(52);
  "string" == typeof (i = i.__esModule ? i.default : i) && (i = [[e.i, i, ""]]);
  var o = {
    insert: "head",
    singleton: !1
  };
  r(i, o);
  e.exports = i.locals || {};
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var r = n(3),
      i = n.n(r)()(!0);
  i.push([e.i, ".recording-error-snackbar{display:flex;align-items:center}.recording-error-snackbar .MuiSnackbarContent-root{background:#df4851}.recording-error-snackbar .MuiSvgIcon-root{font-size:42px;margin-right:5px}.recording-error-snackbar .text{display:flex;flex-direction:column;justify-content:space-around}.recording-error-snackbar .text .main-line{font-size:13px}.recording-error-snackbar .text .sub-line{font-size:11px}", "", {
    version: 3,
    sources: ["webpack://lib/RecordingErrorSnackbar.sass"],
    names: [],
    mappings: "AAAA,0BACI,YAAA,CACA,kBAAA,CAEA,mDACI,kBAAA,CAEJ,2CACI,cAAA,CACA,gBAAA,CAEJ,gCACI,YAAA,CACA,qBAAA,CACA,4BAAA,CACA,2CACI,cAAA,CACJ,0CACI,cAAA",
    sourcesContent: [".recording-error-snackbar\n    display: flex\n    align-items: center\n    \n    .MuiSnackbarContent-root\n        background: #DF4851\n    \n    .MuiSvgIcon-root\n        font-size: 42px\n        margin-right: 5px\n    \n    .text\n        display: flex\n        flex-direction: column\n        justify-content: space-around\n        .main-line\n            font-size: 13px\n        .sub-line\n            font-size: 11px"],
    sourceRoot: ""
  }]), t.default = i;
}, function (e, t, n) {
  var r = n(5),
      i = n(54);
  "string" == typeof (i = i.__esModule ? i.default : i) && (i = [[e.i, i, ""]]);
  var o = {
    insert: "head",
    singleton: !1
  };
  r(i, o);
  e.exports = i.locals || {};
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var r = n(3),
      i = n.n(r)()(!0);
  i.push([e.i, ".inline-multiple-choice-question-prompt{display:flex;flex-direction:column}.inline-multiple-choice-question-prompt .option-button{max-width:300px;margin:5px 0}", "", {
    version: 3,
    sources: ["webpack://lib/InlineMultipleChoiceQuestionPrompt.sass"],
    names: [],
    mappings: "AAAA,wCACI,YAAA,CACA,qBAAA,CACA,uDACI,eAAA,CACA,YAAA",
    sourcesContent: [".inline-multiple-choice-question-prompt\n    display: flex\n    flex-direction: column\n    .option-button\n        max-width: 300px\n        margin: 5px 0"],
    sourceRoot: ""
  }]), t.default = i;
}, function (e, t, n) {
  var r = n(5),
      i = n(56);
  "string" == typeof (i = i.__esModule ? i.default : i) && (i = [[e.i, i, ""]]);
  var o = {
    insert: "head",
    singleton: !1
  };
  r(i, o);
  e.exports = i.locals || {};
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var r = n(3),
      i = n.n(r)()(!0);
  i.push([e.i, ".inline-yes-no-question-prompt{display:flex;align-items:center}.inline-yes-no-question-prompt .buttons .option-button{margin-right:10px}.inline-yes-no-question-prompt .save-indicator .MuiSvgIcon-root{color:#555;margin-left:-1px}", "", {
    version: 3,
    sources: ["webpack://lib/InlineYesNoQuestionPrompt.sass"],
    names: [],
    mappings: "AAAA,+BACI,YAAA,CACA,kBAAA,CAEI,uDACI,iBAAA,CAGJ,gEACI,UAAA,CACA,gBAAA",
    sourcesContent: [".inline-yes-no-question-prompt\n    display: flex\n    align-items: center\n    .buttons\n        .option-button\n            margin-right: 10px\n            \n    .save-indicator\n        .MuiSvgIcon-root\n            color: #555\n            margin-left: -1px\n        "],
    sourceRoot: ""
  }]), t.default = i;
}, function (e, t, n) {
  var r = n(5),
      i = n(58);
  "string" == typeof (i = i.__esModule ? i.default : i) && (i = [[e.i, i, ""]]);
  var o = {
    insert: "head",
    singleton: !1
  };
  r(i, o);
  e.exports = i.locals || {};
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var r = n(3),
      i = n.n(r)()(!0);
  i.push([e.i, ".appointment-scheduler-form{font-family:-apple-system,Roboto,sans-serif}.appointment-scheduler-form.minimized .interested-question{font-size:12px;margin-bottom:10px}.appointment-scheduler-form.minimized .yes-no-interested-buttons{display:flex;align-items:center}.appointment-scheduler-form.minimized .yes-no-interested-buttons .yes-button,.appointment-scheduler-form.minimized .yes-no-interested-buttons .no-button{margin-right:10px}.appointment-scheduler-form.minimized .yes-no-interested-buttons .saving-not-interested{display:inline-flex;align-items:center;font-size:12px}.appointment-scheduler-form.minimized .yes-no-interested-buttons .saving-not-interested .MuiCircularProgress-root{margin-right:10px}.appointment-scheduler-form.minimized .main-control{background:#fff;padding:5px;border:1px solid #e6e6e6;cursor:pointer;margin-bottom:5px;min-height:50px;display:flex;align-items:center}.appointment-scheduler-form.minimized .main-control .MuiSvgIcon-root{font-size:48px;margin-right:10px}.appointment-scheduler-form.minimized .main-control .MuiCircularProgress-root{margin-right:10px;font-size:36px}.appointment-scheduler-form.minimized .main-control .text .main-line{font-size:13px;font-weight:500;margin-bottom:3px}.appointment-scheduler-form.minimized .main-control .text .sub-line{font-size:11px;font-weight:300}.appointment-scheduler-form.minimized .not-interested-button,.appointment-scheduler-form.minimized .change-appt-button,.appointment-scheduler-form.minimized .undo-button{font-size:13px;color:#1a84ff}.appointment-scheduler-form.minimized .not-interested-line{font-size:11px;height:30px;display:flex;align-items:center}.appointment-scheduler-form.minimized .not-interested-line .undo-not-interested-wrapper{width:64px;height:34px;display:flex;justify-content:center;align-items:center}.appointment-scheduler-form.minimized .how-to-change-message{font-size:13px;font-weight:300}.appointment-scheduler-form.maximized{position:relative;background:#fff;height:100%;border:1px solid #ddd}.appointment-scheduler-form.maximized .not-interested-text{padding:20px}.appointment-scheduler-form.maximized .not-interested-text .text{font-size:14px;margin-bottom:20px;line-height:22px}.appointment-scheduler-form.maximized .appointment-taken-message{margin:100px 10px 0 10px;background:#fafafa;padding:10px;box-shadow:5px 5px 10px rgba(0,0,0,.2);border:1px solid #e6e6e6}.appointment-scheduler-form.maximized .appointment-taken-message .main-line{display:flex;align-items:center;font-weight:500}.appointment-scheduler-form.maximized .appointment-taken-message .main-line .MuiSvgIcon-root{font-size:30px;margin-right:5px;color:#f3616a}.appointment-scheduler-form.maximized .appointment-taken-message .sub-line{font-size:13px;margin-top:20px;line-height:18px}.appointment-scheduler-form.maximized .appointment-taken-message .sub-line .MuiButton-root{margin-top:20px}.appointment-scheduler-form.maximized .session-full-message{margin:100px 10px 0 10px;background:#fafafa;padding:10px;box-shadow:5px 5px 10px rgba(0,0,0,.2);border:1px solid #e6e6e6}.appointment-scheduler-form.maximized .session-full-message .main-line{display:flex;align-items:center;font-weight:500}.appointment-scheduler-form.maximized .session-full-message .main-line .MuiSvgIcon-root{font-size:30px;margin-right:5px;color:#f3616a}.appointment-scheduler-form.maximized .session-full-message .sub-line{font-size:13px;margin-top:20px;line-height:18px}.appointment-scheduler-form.maximized .session-full-message .sub-line .MuiButton-root{margin-top:20px}.appointment-scheduler-form.maximized .loading-message,.appointment-scheduler-form.maximized .error-message{position:absolute;display:flex;align-items:center;left:50%;top:50%;transform:translate(-50%, -50%);font-weight:300;font-size:15px}.appointment-scheduler-form.maximized .loading-message .MuiCircularProgress-root,.appointment-scheduler-form.maximized .error-message .MuiCircularProgress-root{margin-right:10px}.appointment-scheduler-form.maximized .loading-message .MuiSvgIcon-root,.appointment-scheduler-form.maximized .error-message .MuiSvgIcon-root{font-size:48px;margin-right:10px;margin-right:10px;color:#df4851}.appointment-scheduler-form.maximized .loading-message .main-line,.appointment-scheduler-form.maximized .error-message .main-line{font-size:14px;font-weight:500;min-width:200px;margin-bottom:5px}.appointment-scheduler-form.maximized .loading-message .sub-line,.appointment-scheduler-form.maximized .error-message .sub-line{font-size:11px}.appointment-scheduler-form.maximized .title{display:flex;justify-content:space-between;align-items:center;padding:0 10px;height:49px;border-bottom:1px solid #ddd;margin-bottom:0}.appointment-scheduler-form.maximized .title .icon-and-title{display:flex;align-items:center}.appointment-scheduler-form.maximized .title .icon-and-title .MuiSvgIcon-root{margin-right:5px}.appointment-scheduler-form.maximized .time-slots{height:calc(100% - 100px);position:relative;overflow:hidden}.appointment-scheduler-form.maximized .time-slots .time-slots-inner{height:100%;overflow:scroll}.appointment-scheduler-form.maximized .time-slots .heading{font-size:12px;height:40px;display:flex;align-items:center;padding:0 10px}.appointment-scheduler-form.maximized .time-slots .available-slots{background:#f6f7f8;padding:10px;margin:0 10px 10px 10px;min-height:200px;position:relative}.appointment-scheduler-form.maximized .time-slots .available-slots .checking-availability-message{display:flex;align-items:center;justify-content:center;font-size:12px;margin-top:80px}.appointment-scheduler-form.maximized .time-slots .available-slots .checking-availability-message .MuiCircularProgress-root{margin-right:10px}.appointment-scheduler-form.maximized .time-slots .available-slots .option-button{margin-bottom:10px;text-transform:none}.appointment-scheduler-form.maximized .time-slots .available-slots .option-button .button-label{width:calc(100% - 20px);display:flex;justify-content:space-between;align-items:center;font-weight:400;font-size:14px}.appointment-scheduler-form.maximized .time-slots .available-slots .option-button .slot-count{font-size:12px;font-weight:300}.appointment-scheduler-form.maximized .time-slots .available-slots .available-times .focused-date-header{display:flex;align-items:center}.appointment-scheduler-form.maximized .time-slots .available-slots .available-times .time-buttons .time-button{margin-bottom:10px;font-weight:400;font-size:14px}.appointment-scheduler-form.maximized .bottom-bar{border-top:1px solid #ddd;height:49px;display:flex;align-items:center;padding:0 10px}.appointment-scheduler-form.maximized .scheduling-overlay{background:rgba(255,255,255,.4);backdrop-filter:blur(1px);position:absolute;top:0;left:0;width:100%;height:100%}.appointment-scheduler-form.maximized .scheduling-overlay .scheduling-progress{position:absolute;left:calc(50% - 25px);top:calc(50% - 25px)}.appointment-scheduler-fullscreen-wrapper{max-width:720px;z-index:10000;position:fixed;width:100%;height:100%;top:0;left:50%;transform:translateX(-50%)}", "", {
    version: 3,
    sources: ["webpack://lib/AppointmentSchedulerForm.sass"],
    names: [],
    mappings: "AAAA,4BACI,2CAAA,CAII,2DACI,cAAA,CACA,kBAAA,CAEJ,iEACI,YAAA,CACA,kBAAA,CACA,yJACI,iBAAA,CAEJ,wFACI,mBAAA,CACA,kBAAA,CAGA,cAAA,CAFA,kHACI,iBAAA,CAGZ,oDACI,eAAA,CACA,WAAA,CACA,wBAAA,CACA,cAAA,CACA,iBAAA,CACA,eAAA,CACA,YAAA,CACA,kBAAA,CAEA,qEACI,cAAA,CACA,iBAAA,CAEJ,8EACI,iBAAA,CACA,cAAA,CAGA,qEACI,cAAA,CACA,eAAA,CACA,iBAAA,CAEJ,oEACI,cAAA,CACA,eAAA,CAEZ,0KACI,cAAA,CACA,aAAA,CAIJ,2DACI,cAAA,CACA,WAAA,CACA,YAAA,CACA,kBAAA,CAEA,wFACI,UAAA,CACA,WAAA,CACA,YAAA,CACA,sBAAA,CACA,kBAAA,CAER,6DACI,cAAA,CACA,eAAA,CAGR,sCACI,iBAAA,CACA,eAAA,CACA,WAAA,CACA,qBAAA,CAEA,2DACI,YAAA,CAEA,iEACI,cAAA,CACA,kBAAA,CACA,gBAAA,CAER,iEACI,wBAAA,CACA,kBAAA,CACA,YAAA,CACA,sCAAA,CACA,wBAAA,CAEA,4EACI,YAAA,CACA,kBAAA,CACA,eAAA,CACA,6FACI,cAAA,CACA,gBAAA,CACA,aAAA,CAER,2EACI,cAAA,CACA,eAAA,CACA,gBAAA,CAEA,2FACI,eAAA,CAEZ,4DACI,wBAAA,CACA,kBAAA,CACA,YAAA,CACA,sCAAA,CACA,wBAAA,CAEA,uEACI,YAAA,CACA,kBAAA,CACA,eAAA,CACA,wFACI,cAAA,CACA,gBAAA,CACA,aAAA,CAER,sEACI,cAAA,CACA,eAAA,CACA,gBAAA,CAEA,sFACI,eAAA,CAGZ,4GACI,iBAAA,CACA,YAAA,CACA,kBAAA,CACA,QAAA,CACA,OAAA,CACA,+BAAA,CACA,eAAA,CACA,cAAA,CAEA,gKACI,iBAAA,CAEJ,8IACI,cAAA,CACA,iBAAA,CACA,iBAAA,CACA,aAAA,CAEJ,kIACI,cAAA,CACA,eAAA,CACA,eAAA,CACA,iBAAA,CAEJ,gIACI,cAAA,CAGR,6CACI,YAAA,CACA,6BAAA,CACA,kBAAA,CACA,cAAA,CACA,WAAA,CACA,4BAAA,CACA,eAAA,CAEA,6DACI,YAAA,CACA,kBAAA,CAEA,8EACI,gBAAA,CAEZ,kDACI,yBAAA,CACA,iBAAA,CACA,eAAA,CAGA,oEACI,WAAA,CACA,eAAA,CAEJ,2DACI,cAAA,CACA,WAAA,CACA,YAAA,CACA,kBAAA,CACA,cAAA,CAEJ,mEACI,kBAAA,CACA,YAAA,CACA,uBAAA,CACA,gBAAA,CACA,iBAAA,CAEA,kGACI,YAAA,CACA,kBAAA,CACA,sBAAA,CACA,cAAA,CACA,eAAA,CACA,4HACI,iBAAA,CAER,kFACI,kBAAA,CACA,mBAAA,CAEA,gGACI,uBAAA,CACA,YAAA,CACA,6BAAA,CACA,kBAAA,CACA,eAAA,CACA,cAAA,CAEJ,8FACI,cAAA,CACA,eAAA,CAGJ,yGACI,YAAA,CACA,kBAAA,CAIA,+GACI,kBAAA,CACA,eAAA,CACA,cAAA,CAGpB,kDACI,yBAAA,CACA,WAAA,CACA,YAAA,CACA,kBAAA,CACA,cAAA,CAEJ,0DACI,+BAAA,CACA,yBAAA,CACA,iBAAA,CACA,KAAA,CACA,MAAA,CACA,UAAA,CACA,WAAA,CAEA,+EACI,iBAAA,CACA,qBAAA,CACA,oBAAA,CAKhB,0CACI,eAAA,CACA,aAAA,CACA,cAAA,CACA,UAAA,CACA,WAAA,CACA,KAAA,CACA,QAAA,CACA,0BAAA",
    sourcesContent: [".appointment-scheduler-form\n    font-family: -apple-system, Roboto, sans-serif\n    \n    &.minimized\n    \n        .interested-question\n            font-size: 12px\n            margin-bottom: 10px\n            \n        .yes-no-interested-buttons\n            display: flex\n            align-items: center\n            .yes-button, .no-button\n                margin-right: 10px\n                \n            .saving-not-interested\n                display: inline-flex\n                align-items: center\n                .MuiCircularProgress-root\n                    margin-right: 10px\n                font-size: 12px\n        \n        .main-control\n            background: #fff\n            padding: 5px\n            border: 1px solid #e6e6e6\n            cursor: pointer\n            margin-bottom: 5px\n            min-height: 50px\n            display: flex\n            align-items: center\n        \n            .MuiSvgIcon-root\n                font-size: 48px\n                margin-right: 10px\n                \n            .MuiCircularProgress-root\n                margin-right: 10px\n                font-size: 36px\n                \n            .text\n                .main-line\n                    font-size: 13px\n                    font-weight: 500\n                    margin-bottom: 3px\n                    \n                .sub-line\n                    font-size: 11px\n                    font-weight: 300\n                    \n        .not-interested-button, .change-appt-button, .undo-button\n            font-size: 13px\n            color: #1A84FF\n            \n        \n            \n        .not-interested-line\n            font-size: 11px\n            height: 30px\n            display: flex\n            align-items: center\n            \n            .undo-not-interested-wrapper\n                width: 64px\n                height: 34px\n                display: flex\n                justify-content: center\n                align-items: center\n                \n        .how-to-change-message\n            font-size: 13px\n            font-weight: 300\n            \n            \n    &.maximized\n        position: relative\n        background: #fff\n        height: 100%\n        border: 1px solid #ddd\n        \n        .not-interested-text\n            padding: 20px\n            \n            .text\n                font-size: 14px\n                margin-bottom: 20px\n                line-height: 22px\n                \n        .appointment-taken-message\n            margin: 100px 10px 0 10px\n            background: #fafafa\n            padding: 10px\n            box-shadow: 5px 5px 10px rgba(0,0,0,0.2)\n            border: 1px solid #e6e6e6\n            \n            .main-line\n                display: flex\n                align-items: center\n                font-weight: 500\n                .MuiSvgIcon-root\n                    font-size: 30px\n                    margin-right: 5px\n                    color: #F3616A\n                    \n            .sub-line\n                font-size: 13px\n                margin-top: 20px\n                line-height: 18px\n                \n                .MuiButton-root\n                    margin-top: 20px\n                    \n        .session-full-message\n            margin: 100px 10px 0 10px\n            background: #fafafa\n            padding: 10px\n            box-shadow: 5px 5px 10px rgba(0,0,0,0.2)\n            border: 1px solid #e6e6e6\n            \n            .main-line\n                display: flex\n                align-items: center\n                font-weight: 500\n                .MuiSvgIcon-root\n                    font-size: 30px\n                    margin-right: 5px\n                    color: #F3616A\n                    \n            .sub-line\n                font-size: 13px\n                margin-top: 20px\n                line-height: 18px\n                \n                .MuiButton-root\n                    margin-top: 20px\n        \n        \n        .loading-message, .error-message\n            position: absolute\n            display: flex\n            align-items: center\n            left: 50%\n            top: 50%\n            transform: translate(-50%, -50%)\n            font-weight: 300\n            font-size: 15px\n            \n            .MuiCircularProgress-root\n                margin-right: 10px\n                \n            .MuiSvgIcon-root\n                font-size: 48px\n                margin-right: 10px\n                margin-right: 10px\n                color: #DF4851\n                \n            .main-line\n                font-size: 14px\n                font-weight: 500\n                min-width: 200px\n                margin-bottom: 5px\n                \n            .sub-line\n                font-size: 11px\n                \n        \n        .title\n            display: flex\n            justify-content: space-between\n            align-items: center\n            padding: 0 10px \n            height: 49px\n            border-bottom: 1px solid #ddd\n            margin-bottom: 0\n            \n            .icon-and-title\n                display: flex\n                align-items: center\n                \n                .MuiSvgIcon-root\n                    margin-right: 5px\n                    \n        .time-slots\n            height: calc(100% - 100px)\n            position: relative\n            overflow: hidden\n            \n            \n            .time-slots-inner\n                height: 100%\n                overflow: scroll\n            \n            .heading\n                font-size: 12px\n                height: 40px\n                display: flex\n                align-items: center\n                padding: 0 10px\n                \n            .available-slots\n                background: #f6f7f8\n                padding: 10px\n                margin: 0 10px 10px 10px\n                min-height: 200px\n                position: relative\n                \n                .checking-availability-message\n                    display: flex\n                    align-items: center\n                    justify-content: center\n                    font-size: 12px\n                    margin-top: 80px\n                    .MuiCircularProgress-root\n                        margin-right: 10px\n                        \n                .option-button\n                    margin-bottom: 10px\n                    text-transform: none\n                    \n                    .button-label\n                        width: calc(100% - 20px)\n                        display: flex\n                        justify-content: space-between\n                        align-items: center\n                        font-weight: 400\n                        font-size: 14px\n                    \n                    .slot-count\n                        font-size: 12px\n                        font-weight: 300\n                        \n                .available-times\n                    .focused-date-header\n                        display: flex\n                        align-items: center\n                        \n                    .time-buttons\n                    \n                        .time-button\n                            margin-bottom: 10px\n                            font-weight: 400\n                            font-size: 14px\n            \n        \n        .bottom-bar\n            border-top: 1px solid #ddd\n            height: 49px\n            display: flex\n            align-items: center \n            padding: 0 10px\n            \n        .scheduling-overlay\n            background: rgba(255,255,255,0.4)\n            backdrop-filter: blur(1px)\n            position: absolute\n            top: 0\n            left: 0\n            width: 100%\n            height: 100%\n            \n            .scheduling-progress\n                position: absolute\n                left: calc(50% - 25px)\n                top: calc(50% - 25px)\n                \n            \n                \n    \n.appointment-scheduler-fullscreen-wrapper\n    max-width: 720px\n    z-index: 10000\n    position: fixed\n    width: 100%\n    height: 100%\n    top: 0\n    left:50%\n    transform: translateX(-50%)"],
    sourceRoot: ""
  }]), t.default = i;
}, function (e, t, n) {
  var r = n(5),
      i = n(60);
  "string" == typeof (i = i.__esModule ? i.default : i) && (i = [[e.i, i, ""]]);
  var o = {
    insert: "head",
    singleton: !1
  };
  r(i, o);
  e.exports = i.locals || {};
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var r = n(3),
      i = n.n(r)()(!0);
  i.push([e.i, ".saving-button{width:100%}.saving-button .after-saving-message,.saving-button .after-error-message{font-size:13px;margin-top:10px}.saving-button .after-error-message{display:flex;align-items:center}.saving-button .after-error-message .MuiSvgIcon-root{color:#f3616a;margin-right:5px}", "", {
    version: 3,
    sources: ["webpack://lib/SavingButton.sass"],
    names: [],
    mappings: "AAAA,eACI,UAAA,CACA,yEACI,cAAA,CACA,eAAA,CAEJ,oCACI,YAAA,CACA,kBAAA,CACA,qDACI,aAAA,CACA,gBAAA",
    sourcesContent: [".saving-button\n    width: 100%\n    .after-saving-message, .after-error-message\n        font-size: 13px\n        margin-top: 10px\n        \n    .after-error-message\n        display: flex\n        align-items: center\n        .MuiSvgIcon-root\n            color: #F3616A\n            margin-right: 5px\n"],
    sourceRoot: ""
  }]), t.default = i;
}, function (e, t, n) {
  "use strict";

  n.r(t), n.d(t, "FullScreenStackedForm", function () {
    return Ae;
  }), n.d(t, "InlineMultipleChoiceQuestionPrompt", function () {
    return me;
  }), n.d(t, "InlineYesNoQuestionPrompt", function () {
    return de;
  }), n.d(t, "areAllQuestionsAnswered", function () {
    return g;
  }), n.d(t, "AppointmentSchedulerForm", function () {
    return je;
  }), n.d(t, "MinimizedSchedulerForm", function () {
    return ze;
  }), n.d(t, "MaximizedSchedulerForm", function () {
    return qe;
  }), n.d(t, "NotInterestedSchedulerFormPopup", function () {
    return Pe;
  }), n.d(t, "SavingButton", function () {
    return Re;
  }), n.d(t, "ThirdPartySchedulerForm", function () {
    return Ue;
  });
  n(28);
  var r = n(0),
      i = n.n(r),
      o = n(4),
      a = n.n(o),
      s = n(19);

  function l(e, t, n, r, i, o, a) {
    try {
      var s = e[o](a),
          l = s.value;
    } catch (e) {
      return void n(e);
    }

    s.done ? t(l) : Promise.resolve(l).then(r, i);
  }

  function c(e) {
    return function () {
      var t = this,
          n = arguments;
      return new Promise(function (r, i) {
        var o = e.apply(t, n);

        function a(e) {
          l(o, r, i, a, s, "next", e);
        }

        function s(e) {
          l(o, r, i, a, s, "throw", e);
        }

        a(void 0);
      });
    };
  }

  function u(e, t) {
    var _n;

    if ("undefined" == typeof Symbol || null == e[Symbol.iterator]) {
      if (Array.isArray(e) || (_n = function (e, t) {
        if (!e) return;
        if ("string" == typeof e) return A(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === n && e.constructor && (n = e.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(e);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return A(e, t);
      }(e)) || t && e && "number" == typeof e.length) {
        _n && (e = _n);

        var r = 0,
            i = function i() {};

        return {
          s: i,
          n: function n() {
            return r >= e.length ? {
              done: !0
            } : {
              done: !1,
              value: e[r++]
            };
          },
          e: function e(_e2) {
            throw _e2;
          },
          f: i
        };
      }

      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    var o,
        a = !0,
        s = !1;
    return {
      s: function s() {
        _n = e[Symbol.iterator]();
      },
      n: function n() {
        var e = _n.next();

        return a = e.done, e;
      },
      e: function e(_e3) {
        s = !0, o = _e3;
      },
      f: function f() {
        try {
          a || null == _n.return || _n.return();
        } finally {
          if (s) throw o;
        }
      }
    };
  }

  function A(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }

    return r;
  }

  function m(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function p(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? m(Object(n), !0).forEach(function (t) {
        f(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : m(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function f(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  function d(e, t) {
    if (!e.displayRule) return Promise.resolve(!0);
    var n = new s.Engine();
    return n.addRule(p(p({}, e.displayRule), {}, {
      event: {
        type: "showQuestion",
        params: {
          showQuestion: !0
        }
      }
    })), n.run({
      answers: t
    }).then(function (e) {
      var t,
          n = u(e.events);

      try {
        for (n.s(); !(t = n.n()).done;) {
          if (!0 === t.value.params.showQuestion) return !0;
        }
      } catch (e) {
        n.e(e);
      } finally {
        n.f();
      }

      return !1;
    });
  }

  function g(e, t) {
    return h.apply(this, arguments);
  }

  function h() {
    return (h = c(_regeneratorRuntime.mark(function e(t, n) {
      var r, i;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (r = _.filter(t.questions, function (e) {
                var t = e.id;
                return !_.has(n, t);
              }), !_.isEmpty(r)) {
                e.next = 3;
                break;
              }

              return e.abrupt("return", !0);

            case 3:
              return e.next = 5, Promise.all(_.map(r, function (e) {
                return d(e, n);
              }));

            case 5:
              return i = e.sent, e.abrupt("return", _.isEmpty(_.filter(i)));

            case 7:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))).apply(this, arguments);
  }

  var C = new Set(["five-star-rating", "yes-no", "multiple-choice"]);

  function v(e) {
    var t = function (e) {
      return 7.5 * _.reduce(e.questions, function (e, t) {
        return C.has(t.type) ? e + 1 : "checkbox" === t.type ? e + Math.ceil(_.size(t.options) / 2) : void 0;
      }, 0);
    }(e),
        n = Math.round(t / 60);

    return t <= 45 ? "less than 1 minute" : "approximately ".concat(n, " minute").concat(1 === n ? "" : "s");
  }

  var b = n(2),
      y = n.n(b),
      x = (n(42), n(1));

  function w(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function E(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? w(Object(n), !0).forEach(function (t) {
        k(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : w(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function k(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  function I(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var n = [],
          r = !0,
          i = !1,
          o = void 0;

      try {
        for (var a, s = e[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
          ;
        }
      } catch (e) {
        i = !0, o = e;
      } finally {
        try {
          r || null == s.return || s.return();
        } finally {
          if (i) throw o;
        }
      }

      return n;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return O(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === n && e.constructor && (n = e.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(e);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return O(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function O(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }

    return r;
  }

  function N(e) {
    var t = e.question,
        n = e.updateAnswers,
        o = I(Object(r.useState)(""), 2),
        a = o[0],
        s = o[1],
        l = I(Object(r.useState)({}), 2),
        c = l[0],
        u = l[1],
        A = t.id,
        m = t.prompt,
        p = t.options,
        f = t.includeCustom,
        d = _.debounce(s, 300),
        g = _.clone(p);

    return f && g.push({
      isCustom: !0
    }), i.a.createElement("div", {
      className: "messaging-form-question checkbox-question"
    }, i.a.createElement("div", {
      className: "prompt"
    }, m), i.a.createElement("div", {
      className: "options"
    }, _.map(g, function (e) {
      var t = e.value,
          n = e.text,
          r = e.isCustom;
      return i.a.createElement(x.FormControlLabel, {
        key: r ? "custom" : t,
        value: r ? a : t,
        label: r ? i.a.createElement(x.TextField, {
          className: "custom-value-textfield",
          defaultValue: a,
          placeholder: "other...",
          onChange: function onChange(e) {
            var t = e.target.value.trim();
            d(t), _.has(c, "(custom)") && u(E(E({}, c), {}, {
              "(custom)": t
            }));
          }
        }) : n,
        control: i.a.createElement(x.Checkbox, {
          color: "primary",
          onChange: function onChange(e) {
            var t = e.target,
                n = t.value,
                i = t.checked,
                o = E({}, c);
            r ? i && !_.isEmpty(a) ? o["(custom)"] = a : delete o["(custom)"] : i ? o[n] = !0 : delete o[n], u(o);
          }
        })
      });
    })), i.a.createElement("div", {
      className: "actions"
    }, i.a.createElement(x.Button, {
      className: "next-button",
      variant: "contained",
      color: "primary",
      onClick: function onClick() {
        var e = _.map(_.keys(c), function (e) {
          return "(custom)" === e ? c[e] : e;
        });

        n(e, A);
      }
    }, "Next")));
  }

  n(44);

  function B(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var n = [],
          r = !0,
          i = !1,
          o = void 0;

      try {
        for (var a, s = e[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
          ;
        }
      } catch (e) {
        i = !0, o = e;
      } finally {
        try {
          r || null == s.return || s.return();
        } finally {
          if (i) throw o;
        }
      }

      return n;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return S(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === n && e.constructor && (n = e.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(e);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return S(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function S(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }

    return r;
  }

  function j(e) {
    var t = e.question,
        n = e.value,
        o = e.updateAnswers,
        a = B(Object(r.useState)(_.isEmpty(_.trim(n))), 2),
        s = a[0],
        l = a[1],
        c = Object(r.useRef)(),
        u = t.id,
        A = t.prompt;
    return i.a.createElement("div", {
      className: "messaging-form-question free-text-question"
    }, i.a.createElement("div", {
      className: "prompt"
    }, A), i.a.createElement(x.TextField, {
      inputRef: c,
      className: "free-text-textfield",
      multiline: !0,
      fullWidth: !0,
      defaultValue: n,
      placeholder: "answer...",
      onChange: function onChange(e) {
        l(_.isEmpty(_.trim(e.target.value)));
      }
    }), i.a.createElement("div", {
      className: "actions"
    }, i.a.createElement(x.Button, {
      className: "next-button",
      variant: "contained",
      color: "primary",
      disabled: s,
      onClick: function onClick() {
        o(c.current.value.trim(), u);
      }
    }, "Next")));
  }

  n(46);

  function z(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
        n = M(e);
    if (n) return "rgba(".concat(n[0], ",").concat(n[1], ",").concat(n[2], ",").concat(t, ")");
  }

  function M(e) {
    var t = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e);
    if (t) return [parseInt(t[1], 16), parseInt(t[2], 16), parseInt(t[3], 16)];
  }

  function P(e, t) {
    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 25;
    return y.a.find(t, function (t) {
      return q(e, t) >= n;
    });
  }

  function q(e, t) {
    e = M(e), t = M(t);
    var n = F(e),
        r = F(t),
        i = n[0] - r[0],
        o = n[1] - r[1],
        a = n[2] - r[2],
        s = Math.sqrt(n[1] * n[1] + n[2] * n[2]),
        l = s - Math.sqrt(r[1] * r[1] + r[2] * r[2]),
        c = o * o + a * a - l * l,
        u = i / 1,
        A = l / (1 + .045 * s),
        m = (c = c < 0 ? 0 : Math.sqrt(c)) / (1 + .015 * s),
        p = u * u + A * A + m * m;
    return p < 0 ? 0 : Math.sqrt(p);
  }

  function F(e) {
    var t,
        n,
        r,
        i = e[0] / 255,
        o = e[1] / 255,
        a = e[2] / 255;
    return n = (.2126 * (i = i > .04045 ? Math.pow((i + .055) / 1.055, 2.4) : i / 12.92) + .7152 * (o = o > .04045 ? Math.pow((o + .055) / 1.055, 2.4) : o / 12.92) + .0722 * (a = a > .04045 ? Math.pow((a + .055) / 1.055, 2.4) : a / 12.92)) / 1, r = (.0193 * i + .1192 * o + .9505 * a) / 1.08883, t = (t = (.4124 * i + .3576 * o + .1805 * a) / .95047) > .008856 ? Math.pow(t, 1 / 3) : 7.787 * t + 16 / 116, [116 * (n = n > .008856 ? Math.pow(n, 1 / 3) : 7.787 * n + 16 / 116) - 16, 500 * (t - n), 200 * (n - (r = r > .008856 ? Math.pow(r, 1 / 3) : 7.787 * r + 16 / 116))];
  }

  function D(e) {
    var t = e.question,
        n = e.value,
        r = e.updateAnswers,
        o = e.primaryColor,
        a = e.primaryFgColor,
        s = t.id,
        l = t.prompt,
        c = t.options;
    return i.a.createElement("div", {
      className: "messaging-form-question multiple-choice-question"
    }, i.a.createElement("div", {
      className: "prompt"
    }, l), i.a.createElement("div", {
      className: "option-buttons"
    }, _.map(c, function (e) {
      var t = e.value === n;
      return i.a.createElement(x.Button, {
        key: e.value,
        className: "option-button",
        onClick: function onClick() {
          return r(e.value, s);
        },
        style: {
          backgroundColor: z(o, t ? 1 : .2),
          color: t ? a : "#000"
        }
      }, e.text);
    })));
  }

  var R = n(7),
      T = n.n(R),
      Y = n(13),
      J = n.n(Y),
      U = n(14),
      W = n.n(U),
      V = (n(48), n(20)),
      G = n.n(V),
      L = (n(50), n(21)),
      H = n.n(L);

  function K(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var n = [],
          r = !0,
          i = !1,
          o = void 0;

      try {
        for (var a, s = e[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
          ;
        }
      } catch (e) {
        i = !0, o = e;
      } finally {
        try {
          r || null == s.return || s.return();
        } finally {
          if (i) throw o;
        }
      }

      return n;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return Q(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === n && e.constructor && (n = e.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(e);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Q(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function Q(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }

    return r;
  }

  function $(e) {
    var t = e.question,
        n = e.value,
        o = e.updateAnswers,
        a = (e.primaryColor, K(Object(r.useState)(n), 2)),
        s = a[0],
        l = a[1],
        c = t.id,
        u = t.prompt;
    return i.a.createElement("div", {
      className: "messaging-form-question five-star-rating-question"
    }, i.a.createElement("div", {
      className: "prompt"
    }, u), i.a.createElement("div", {
      className: "stars"
    }, _.map(_.times(5), function (e) {
      var t = _.isFinite(s) && e < s;
      return i.a.createElement("span", {
        key: e
      }, i.a.createElement(G.a, {
        className: "star-outline ".concat(t ? "selected" : ""),
        onClick: function onClick() {
          l(e + 1), o(e + 1, c);
        }
      }), i.a.createElement(H.a, {
        className: "star-inner ".concat(t ? "selected" : "")
      }));
    })), i.a.createElement("div", {
      className: "star-labels"
    }, i.a.createElement("span", {
      className: "label"
    }, "Very Bad"), i.a.createElement("span", {
      className: "label"
    }, "Very Good")));
  }

  n(51);
  var Z = n(6),
      X = n.n(Z);

  function ee(e) {
    var t = e.open,
        n = e.onClose;
    return i.a.createElement("div", {
      className: "recording-error-snackbar"
    }, i.a.createElement(x.Snackbar, {
      open: t,
      onClose: n,
      autoHideDuration: 5e4,
      message: i.a.createElement("div", {
        className: "recording-error-snackbar"
      }, i.a.createElement(X.a, null), i.a.createElement("div", {
        className: "text"
      }, i.a.createElement("div", {
        className: "main-line"
      }, "Unexpected error recording your response."), i.a.createElement("div", {
        className: "sub-line"
      }, "Please try again later.")))
    }));
  }

  var te = n(22),
      ne = n.n(te),
      re = n(23),
      ie = n.n(re);

  function oe() {
    return (oe = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function ae(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function se(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? ae(Object(n), !0).forEach(function (t) {
        le(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ae(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function le(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  function ce(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var n = [],
          r = !0,
          i = !1,
          o = void 0;

      try {
        for (var a, s = e[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
          ;
        }
      } catch (e) {
        i = !0, o = e;
      } finally {
        try {
          r || null == s.return || s.return();
        } finally {
          if (i) throw o;
        }
      }

      return n;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return ue(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === n && e.constructor && (n = e.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(e);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ue(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function ue(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }

    return r;
  }

  function Ae(e) {
    var t = e.title,
        n = e.formDefinition,
        o = e.onAnswer,
        a = e.onDone,
        s = e.onClose,
        l = e.onFullScreenOpen,
        c = e.isRecorded,
        u = e.onSend,
        A = e.primaryColor,
        m = e.secondaryColor,
        p = e.completedAtMillis,
        f = e.allowEditingAnswers,
        d = ce(Object(r.useState)(!1), 2),
        h = d[0],
        C = d[1],
        b = ce(Object(r.useState)(y.a.get(n, "answers", {})), 2),
        w = b[0],
        E = b[1],
        k = ce(Object(r.useState)(null), 2),
        I = k[0],
        O = k[1],
        B = ce(Object(r.useState)(!1), 2),
        S = B[0],
        M = B[1],
        q = ce(Object(r.useState)(null), 2),
        _ = q[0],
        F = q[1],
        R = ce(Object(r.useState)(!1), 2),
        Y = R[0],
        U = R[1],
        V = ce(Object(r.useState)(!1), 2),
        G = V[0],
        L = V[1],
        H = function H(e) {
      C(e), y.a.isFunction(l) && l(e);
    },
        K = Object(r.useMemo)(function () {
      return P(A, ["#ffffff", "#000000"]);
    }, [A]),
        Q = Object(r.useMemo)(function () {
      return P(m, ["#ffffff", "#000000"]);
    }, [m]);

    Object(r.useEffect)(function () {
      g(n, w).then(function (e) {
        e != I && (O(e), a(w));
      });
    }, [JSON.stringify(w)]), Object(r.useEffect)(function () {
      Y && L(!y.a.isEqual(n.answers, w));
    }, [n.answers, w, Y]);

    var Z = Object(r.useMemo)(function () {
      return v(n);
    }, [n]),
        X = function X(e, t) {
      var n = se(se({}, w), {}, le({}, t, e));
      E(n), o({
        answer: e,
        questionId: t
      });
    };

    if (y.a.isNil(I)) return null;
    var te = !I || S || c && !Y || Y && !G;
    return i.a.createElement("div", null, i.a.createElement("div", {
      className: "messaging-form closed ".concat(!c || f ? "openable" : ""),
      onClick: function onClick() {
        c && !f || H(!0);
      }
    }, i.a.createElement("div", {
      className: "icon-and-text"
    }, c ? i.a.createElement(W.a, {
      style: {
        color: A
      }
    }) : i.a.createElement(J.a, {
      style: {
        color: A
      }
    }), i.a.createElement("div", null, i.a.createElement("div", {
      className: "main-line"
    }, t), i.a.createElement("div", {
      className: "sub-line"
    }, c ? "Thank you for completing this brief survey" : "Tap to open brief survey from your pharmacist"))), i.a.createElement("div", {
      className: "time-estimate-or-completed-at"
    }, c ? i.a.createElement("div", {
      className: "estimated-time",
      style: {
        background: z(A, .15),
        boxShadow: "2px 2px 4px rgba(0,0,0,0)",
        border: "1px solid ".concat(z(A, .2))
      }
    }, "Completed ", ie()(p).fromNow()) : i.a.createElement("div", {
      className: "estimated-time"
    }, i.a.createElement(ne.a, null), " ", i.a.createElement("span", null, "should take ", i.a.createElement("span", {
      className: "time"
    }, Z))))), h ? i.a.createElement("div", {
      className: "messaging-form ".concat(h ? "fullscreen" : "")
    }, i.a.createElement("div", {
      className: "messaging-form-inner"
    }, i.a.createElement("div", {
      className: "title"
    }, i.a.createElement("span", {
      className: "icon-and-title"
    }, i.a.createElement(J.a, {
      style: {
        color: A
      }
    }), " ", t), i.a.createElement(x.IconButton, {
      onClick: function onClick() {
        H(!1), s(w), Y && U(!1);
      }
    }, i.a.createElement(T.a, null))), i.a.createElement("div", {
      className: "main-content ".concat(S ? "sending" : "")
    }, i.a.createElement("div", {
      className: "questions-wrapper",
      style: {
        height: "".concat(window.innerHeight - 100, "px")
      }
    }, i.a.createElement("div", {
      className: "questions"
    }, y.a.map(n.questions, function (e) {
      return i.a.createElement("div", {
        key: e.id,
        className: "fullscreen-question-wrapper ".concat(y.a.has(w, e.id) ? "done" : "")
      }, function (e, t, n, r, o, a, s) {
        var l = {
          primaryColor: r,
          secondaryColor: o,
          primaryFgColor: a,
          secondaryFgColor: s
        };

        switch (e.type) {
          case "multiple-choice":
            return i.a.createElement(D, oe({
              key: e.id,
              question: e,
              updateAnswers: n,
              value: t
            }, l));

          case "yes-no":
            return i.a.createElement(D, oe({
              key: e.id,
              question: se(se({}, e), {}, {
                options: [{
                  text: "Yes",
                  value: "yes"
                }, {
                  text: "No",
                  value: "no"
                }]
              }),
              updateAnswers: n,
              value: t
            }, l));

          case "checkbox":
            return i.a.createElement(N, oe({
              key: e.id,
              question: e,
              updateAnswers: n,
              value: t
            }, l));

          case "text":
            return i.a.createElement(j, oe({
              key: e.id,
              question: e,
              updateAnswers: n,
              value: t
            }, l));

          case "five-star-rating":
            return i.a.createElement($, oe({
              key: e.id,
              question: e,
              updateAnswers: n,
              value: y.a.isString(t) ? parseInt(t) : t
            }, l));

          default:
            return null;
        }
      }(e, w[e.id], X, A, m, K, Q), i.a.createElement("div", {
        className: "left-bar",
        style: {
          background: A
        }
      }));
    }))), i.a.createElement("div", {
      className: "done-action"
    }, i.a.createElement(x.Button, {
      className: "send-button",
      fullWidth: !0,
      variant: "contained",
      style: {
        backgroundColor: te ? "#eee" : z(m, 1),
        color: te ? null : Q
      },
      disabled: te,
      onClick: function onClick() {
        M(!0), u(w).then(function () {
          H(!1), M(!1), Y && U(!1);
        }).catch(function (e) {
          M(!1), F(e), H(!1), Y && U(!1);
        });
      }
    }, "Submit Answers")), S ? i.a.createElement("div", {
      className: "sending-progress"
    }, i.a.createElement(x.CircularProgress, {
      style: {
        color: m
      }
    })) : null), !c || Y ? null : i.a.createElement("div", {
      className: "edit-overlay"
    }, i.a.createElement("div", {
      className: "confirm-edit-dialog"
    }, i.a.createElement("div", {
      className: "main-line"
    }, i.a.createElement(W.a, {
      style: {
        color: A
      }
    }), i.a.createElement("span", null, "You already completed this survey.")), i.a.createElement("div", {
      className: "sub-line"
    }, "Would you like to update your answers?"), i.a.createElement("div", {
      className: "actions"
    }, i.a.createElement(x.Button, {
      className: "cancel-button",
      onClick: function onClick() {
        return H(!1);
      },
      variant: "outlined"
    }, "No Thanks"), i.a.createElement(x.Button, {
      variant: "contained",
      color: "primary",
      style: {
        backgroundColor: z(A, 1),
        color: K
      },
      onClick: function onClick() {
        return U(!0);
      }
    }, "Update")))))) : null, i.a.createElement(ee, {
      open: !y.a.isNil(_),
      onClose: function onClose() {
        return F(null);
      }
    }));
  }

  Ae.propTypes = {
    title: a.a.string.isRequired,
    formDefinition: a.a.object.isRequired,
    onAnswer: a.a.func.isRequired,
    onDone: a.a.func,
    isRecorded: a.a.bool,
    onClose: a.a.func,
    collapsed: a.a.bool,
    setFullscreenOpen: a.a.func,
    fullScreen: a.a.bool,
    fullScreenOpen: a.a.bool,
    onSend: a.a.func,
    completedAtMillis: a.a.number,
    primaryColor: a.a.string,
    secondaryColor: a.a.string,
    allowEditingAnswers: a.a.bool
  }, Ae.defaultProps = {
    collapsed: !1,
    onAnswer: function onAnswer(e) {
      e.answer, e.questionId;
    },
    onDone: function onDone(e) {},
    onClose: function onClose(e) {},
    fullScreenOpen: !1,
    primaryColor: "#00B18F",
    secondaryColor: "#DF4851",
    allowEditingAnswers: !1
  };
  n(53);

  function me(e) {
    var t = e.options,
        n = e.value,
        o = e.primaryColor,
        a = e.updateAnswer,
        s = Object(r.useMemo)(function () {
      return P(o, ["#ffffff", "#000000"]);
    }, [o]);
    return i.a.createElement("div", {
      className: "inline-multiple-choice-question-prompt"
    }, _.map(t, function (e) {
      var t = e.value === n;
      return i.a.createElement(x.Button, {
        key: e.value,
        className: "option-button",
        onClick: function onClick() {
          return a(e.value);
        },
        style: {
          backgroundColor: z(o, t ? 1 : .2),
          color: t ? s : "#000"
        }
      }, e.text);
    }));
  }

  me.defaultProps = {
    primaryColor: "#00B18F"
  };
  n(55);
  var pe = n(24),
      fe = n.n(pe);

  function de(e) {
    var t = e.value,
        n = e.updateAnswer,
        o = e.primaryColor,
        a = e.saveStatus,
        s = Object(r.useMemo)(function () {
      return P(o, ["#ffffff", "#000000"]);
    }, [o]);
    return i.a.createElement("div", {
      className: "inline-yes-no-question-prompt"
    }, i.a.createElement("span", {
      className: "buttons"
    }, i.a.createElement(x.Button, {
      className: "option-button",
      onClick: function onClick() {
        return "yes" !== t ? n("yes") : null;
      },
      style: {
        backgroundColor: z(o, "yes" === t ? 1 : .2),
        color: "yes" === t ? s : "#000"
      }
    }, "Yes"), i.a.createElement(x.Button, {
      className: "option-button",
      onClick: function onClick() {
        return "no" !== t ? n("no") : null;
      },
      style: {
        backgroundColor: z(o, "no" === t ? 1 : .2),
        color: "no" === t ? s : "#000"
      }
    }, "No")), i.a.createElement("span", {
      className: "save-indicator"
    }, _.isNil(a) ? null : "saving" === a ? i.a.createElement(x.CircularProgress, {
      size: 20
    }) : i.a.createElement(fe.a, null)));
  }

  de.propTypes = {
    saveStatus: a.a.oneOf([void 0, "saving", "saved"])
  }, de.defaultProps = {
    primaryColor: "#00B18F"
  };
  n(57);
  var ge = n(9),
      he = n.n(ge),
      Ce = n(25),
      ve = n.n(Ce),
      be = n(8),
      ye = n.n(be),
      xe = n(15),
      we = n.n(xe),
      Ee = n(26),
      ke = n.n(Ee),
      Ie = n(27),
      Oe = n.n(Ie);

  function Ne() {
    return (Ne = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function Be(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var n = [],
          r = !0,
          i = !1,
          o = void 0;

      try {
        for (var a, s = e[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
          ;
        }
      } catch (e) {
        i = !0, o = e;
      } finally {
        try {
          r || null == s.return || s.return();
        } finally {
          if (i) throw o;
        }
      }

      return n;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return Se(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === n && e.constructor && (n = e.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(e);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Se(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function Se(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }

    return r;
  }

  function je(e) {
    var t = e.getPreviouslyScheduledAppointment,
        n = e.getPreviouslySaidNotInterested,
        o = e.getPreviouslySaidContactMeNextTime,
        a = (e.getAreAllSlotsFull, e.fetchAvailableSlots),
        s = e.fetchCalendar,
        l = (e.appointmentLabel, e.showNotInterested, e.onScheduleAppointment, e.onNotInterested, e.primaryColor),
        c = void 0 === l ? "#00B18F" : l,
        u = e.secondaryColor,
        A = void 0 === u ? "#DF4851" : u,
        m = (e.allowPastAppointments, e.pastSchedulingBufferMinutes),
        p = void 0 === m ? 0 : m,
        f = arguments[0],
        d = Object(r.useState)("minimized"),
        g = Be(d, 2),
        h = g[0],
        C = g[1],
        v = Object(r.useState)(!0),
        b = Be(v, 2),
        x = b[0],
        w = (b[1], Object(r.useState)(null)),
        E = Be(w, 2),
        k = E[0],
        I = E[1],
        O = Object(r.useState)(null),
        N = Be(O, 2),
        B = N[0],
        S = (N[1], Object(r.useState)(null)),
        j = Be(S, 2),
        z = j[0],
        M = j[1],
        q = Object(r.useState)(t()),
        _ = Be(q, 2),
        F = _[0],
        D = _[1],
        R = Object(r.useState)(n()),
        T = Be(R, 2),
        Y = T[0],
        J = T[1],
        U = Object(r.useState)(o()),
        W = Be(U, 2),
        V = W[0],
        G = W[1],
        L = Object(r.useState)(!1),
        H = Be(L, 2),
        K = H[0],
        Q = H[1],
        $ = Object(r.useState)(null),
        Z = Be($, 2),
        X = Z[0],
        ee = Z[1],
        te = Object(r.useMemo)(function () {
      return P(c, ["#ffffff", "#000000"]);
    }, [c]),
        ne = Object(r.useMemo)(function () {
      return P(A, ["#ffffff", "#000000"]);
    }, [A]);

    return Object(r.useEffect)(function () {
      s().then(function (e) {
        I(e);
      }).catch(function (e) {
        setCalenderError(e);
      });
    }, []), Object(r.useEffect)(function () {
      !y.a.isNil(k) && y.a.isNil(z) && a().then(function (e) {
        _e(e, k.timezone, p), M(e);
      });
    }, [k, z]), "minimized" === h ? i.a.createElement(ze, Ne({}, f, {
      setView: C,
      chosenDatetime: F,
      notInterested: Y,
      setNotInterested: J,
      sendingNotInterested: K,
      setSendingNotInterested: Q,
      answerToIsInterested: X,
      setAnswerToIsInterested: ee,
      primaryFgColor: te,
      contactMeNextTime: V
    })) : "not-interested" === h ? i.a.createElement("div", {
      className: "appointment-scheduler-fullscreen-wrapper"
    }, i.a.createElement(Pe, Ne({}, f, {
      setView: C,
      setNotInterested: J
    }))) : "all-slots-full" === h ? i.a.createElement("div", {
      className: "appointment-scheduler-fullscreen-wrapper"
    }, i.a.createElement(Me, Ne({}, f, {
      setView: C,
      setContactMeNextTime: G,
      contactMeNextTime: V
    }))) : i.a.createElement("div", {
      className: "appointment-scheduler-fullscreen-wrapper"
    }, i.a.createElement(qe, Ne({}, f, {
      setView: C,
      sendButtonDisabled: x,
      calendar: k,
      calendarError: B,
      availableSlots: z,
      chosenDatetime: F,
      setChosenDatetime: D,
      primaryFgColor: te,
      secondaryFgColor: ne,
      setAvailableSlots: M
    })));
  }

  function ze(e) {
    var t,
        n,
        r,
        o = e.primaryColor,
        a = e.setView,
        s = e.chosenDatetime,
        l = e.appointmentLabel,
        c = e.notInterested,
        u = e.showNotInterested,
        A = e.isThirdPartyScheduler,
        m = e.getAreAllSlotsFull,
        p = (e.contactMeNextTime, e.hasLoadedAvailableSlots);
    return y.a.isNil(s) ? y.a.isBoolean(p) && !p ? i.a.createElement("div", {
      className: "appointment-scheduler-form minimized scheduled"
    }, i.a.createElement("div", {
      className: "main-control"
    }, i.a.createElement(x.CircularProgress, {
      style: {
        color: o
      },
      size: 48
    }), i.a.createElement("div", {
      className: "text"
    }, i.a.createElement("div", {
      className: "main-line"
    }, "Appointment Scheduler"), i.a.createElement("div", {
      className: "sub-line"
    }, "Looking up available appointments...")))) : m() ? i.a.createElement("div", {
      className: "appointment-scheduler-form minimized scheduled"
    }, i.a.createElement("div", {
      className: "main-control",
      onClick: function onClick() {
        return null;
      }
    }, i.a.createElement(he.a, {
      style: {
        color: "#F3616A"
      }
    }), i.a.createElement("div", {
      className: "text"
    }, i.a.createElement("div", {
      className: "main-line"
    }, "Appointment Scheduler"), i.a.createElement("div", {
      className: "sub-line"
    }, "All available slots have been booked!")))) : c ? i.a.createElement("div", {
      className: "appointment-scheduler-form minimized"
    }, i.a.createElement("div", {
      className: "main-control"
    }, i.a.createElement(we.a, {
      style: {
        color: o
      }
    }), i.a.createElement("div", {
      className: "text"
    }, i.a.createElement("div", {
      className: "main-line"
    }, "Thanks for letting us know you are no longer interested!"))), i.a.createElement("div", {
      className: "how-to-change-message"
    }, "If you change your mind please message the pharmacy below.")) : i.a.createElement("div", {
      className: "appointment-scheduler-form minimized"
    }, i.a.createElement("div", {
      className: "interested-question"
    }, "Schedule your ", l, " appointment by tapping the Scheduler below."), A ? i.a.createElement("div", {
      className: "main-control",
      onClick: function onClick() {
        return a("maximized");
      }
    }, i.a.createElement(Oe.a, {
      style: {
        color: o
      }
    }), i.a.createElement("div", {
      className: "text"
    }, i.a.createElement("div", {
      className: "main-line"
    }, "Open Scheduler"), i.a.createElement("div", {
      className: "sub-line"
    }, "Go to appointment scheduler"))) : i.a.createElement("div", {
      className: "main-control",
      onClick: function onClick() {
        return a("maximized");
      }
    }, i.a.createElement(he.a, {
      style: {
        color: o
      }
    }), i.a.createElement("div", {
      className: "text"
    }, i.a.createElement("div", {
      className: "main-line"
    }, "Appointment Scheduler"), i.a.createElement("div", {
      className: "sub-line"
    }, "Tap to view available times"))), u ? i.a.createElement(x.Button, {
      fullWidth: !0,
      onClick: function onClick() {
        return a("not-interested");
      }
    }, "I'm no longer interested") : null) : i.a.createElement("div", {
      className: "appointment-scheduler-form minimized scheduled"
    }, i.a.createElement("div", {
      className: "main-control"
    }, i.a.createElement(he.a, {
      style: {
        color: o
      }
    }), i.a.createElement("div", {
      className: "text"
    }, i.a.createElement("div", {
      className: "main-line"
    }, "Appointment scheduled!"), i.a.createElement("div", {
      className: "sub-line"
    }, "We will see you ", i.a.createElement("span", null, (n = (t = s).date, r = t.time, ye()("".concat(n, " ").concat(r), "YYYY-MM-DD HH:mm:ss").format("ddd, MMM D [at] h:mm a")))))), i.a.createElement("div", {
      className: "how-to-change-message"
    }, "To reschedule or cancel this appointment please message the pharmacy below."));
  }

  function Me(e) {
    var t = e.setView,
        n = e.primaryColor,
        o = e.onContactMeNextTime,
        a = e.setContactMeNextTime,
        s = e.getIsFromWaitlist,
        l = Be(Object(r.useState)(!1), 2),
        c = l[0],
        u = l[1],
        A = {
      backgroundColor: z(n, .2),
      color: "#000"
    };
    return i.a.createElement("div", {
      className: "appointment-scheduler-form maximized"
    }, i.a.createElement("div", {
      className: "title"
    }, i.a.createElement("div", {
      className: "icon-and-title"
    }, i.a.createElement(X.a, {
      style: {
        color: "#F3616A"
      }
    }), " No more appointments available."), i.a.createElement(x.IconButton, {
      onClick: function onClick() {
        t("minimized");
      }
    }, i.a.createElement(T.a, null))), s() ? i.a.createElement("div", {
      className: "not-interested-text"
    }, i.a.createElement("div", {
      className: "text"
    }, "The maximum number of allowed appointments at this time have already been scheduled. If you would like to be contacted next time more appointments are available, please click the button below."), i.a.createElement(x.Button, {
      fullWidth: !0,
      style: A,
      disabled: c,
      onClick: function onClick() {
        u(!0), o().then(function () {
          u(!1), a(!0), t("minimized");
        });
      }
    }, c ? "Sending.." : "Contact me next time")) : i.a.createElement("div", {
      className: "not-interested-text"
    }, i.a.createElement("div", {
      className: "text"
    }, "The maximum number of allowed appointments at this time have already been scheduled. Please message the pharmacy if you would like to schedule an appointment next time they are available.")));
  }

  function Pe(e) {
    var t = e.setView,
        n = e.notInterestedText,
        o = e.primaryColor,
        a = e.onNotInterested,
        s = e.setNotInterested,
        l = Be(Object(r.useState)(!1), 2),
        c = l[0],
        u = l[1],
        A = {
      backgroundColor: z(o, .2),
      color: "#000"
    };
    return i.a.createElement("div", {
      className: "appointment-scheduler-form maximized"
    }, i.a.createElement("div", {
      className: "title"
    }, i.a.createElement("div", {
      className: "icon-and-title"
    }, i.a.createElement(we.a, {
      style: {
        color: o
      }
    }), " Remove you from the waitlist?"), i.a.createElement(x.IconButton, {
      onClick: function onClick() {
        t("minimized");
      }
    }, i.a.createElement(T.a, null))), i.a.createElement("div", {
      className: "not-interested-text"
    }, i.a.createElement("div", {
      className: "text"
    }, n), i.a.createElement(x.Button, {
      fullWidth: !0,
      style: A,
      disabled: c,
      onClick: function onClick() {
        u(!0), a().then(function () {
          u(!1), s(!0), t("minimized");
        });
      }
    }, c ? i.a.createElement("span", {
      style: {
        display: "flex",
        alignItems: "center"
      }
    }, i.a.createElement(x.CircularProgress, {
      size: 20,
      style: {
        color: o
      }
    }), " Removing you...") : "Remove me from waitlist")));
  }

  function qe(e) {
    var t = e.calendar,
        n = e.calendarError,
        o = e.setView,
        a = e.primaryColor,
        s = e.primaryFgColor,
        l = e.secondaryColor,
        c = e.secondaryFgColor,
        u = (e.allowPastAppointments, e.availableSlots),
        A = e.chosenDatetime,
        m = e.setChosenDatetime,
        p = e.onScheduleAppointment,
        f = e.appointmentLabel,
        d = e.setAvailableSlots,
        g = Be(Object(r.useState)(null), 2),
        h = g[0],
        C = g[1],
        v = Be(Object(r.useState)(!1), 2),
        b = v[0],
        w = v[1],
        E = Be(Object(r.useState)(!1), 2),
        k = E[0],
        I = E[1],
        O = Be(Object(r.useState)(!1), 2),
        N = O[0],
        B = O[1],
        S = Be(Object(r.useState)(!1), 2),
        j = S[0],
        M = S[1];
    if (!y.a.isNil(n)) return i.a.createElement("div", {
      className: "appointment-scheduler-form maximized"
    }, i.a.createElement("div", {
      className: "title"
    }, i.a.createElement("div", {
      className: "icon-and-title"
    }, "Error connecting to scheduler"), i.a.createElement(x.IconButton, {
      onClick: function onClick() {
        o("minimized");
      }
    }, i.a.createElement(T.a, null))), i.a.createElement("div", {
      className: "error-message"
    }, i.a.createElement(X.a, null), i.a.createElement("div", {
      className: "text"
    }, i.a.createElement("div", {
      className: "main-line"
    }, "Unable to connect to scheduler"), i.a.createElement("div", {
      className: "sub-line"
    }, "Please make sure you are connected to the internet."))));
    if (y.a.isNil(t)) return i.a.createElement("div", {
      className: "appointment-scheduler-form maximized"
    }, i.a.createElement("div", {
      className: "loading-message"
    }, i.a.createElement(x.CircularProgress, {
      size: 30,
      style: {
        color: a
      }
    }), " Loading scheduling details..."));
    var P = y.a.sortBy(y.a.keys(y.a.get(u, "slots"))),
        q = {
      backgroundColor: z(a, .2),
      color: "#000"
    };
    return i.a.createElement("div", {
      className: "appointment-scheduler-form maximized"
    }, i.a.createElement("div", {
      className: "title"
    }, i.a.createElement("div", {
      className: "icon-and-title"
    }, i.a.createElement(he.a, {
      style: {
        color: a
      }
    }), " ", y.a.get(null, "label"), f), i.a.createElement(x.IconButton, {
      onClick: function onClick() {
        o("minimized");
      }
    }, i.a.createElement(T.a, null))), i.a.createElement("div", {
      className: "time-slots"
    }, i.a.createElement("div", {
      className: "time-slots-inner"
    }, i.a.createElement("div", {
      className: "heading"
    }, "Please select a time block below for your appointment."), y.a.isNil(u) ? i.a.createElement("div", {
      className: "available-slots loading"
    }, i.a.createElement("div", {
      className: "checking-availability-message"
    }, i.a.createElement(x.CircularProgress, {
      size: 30,
      style: {
        color: a
      }
    }), " Checking availability...")) : i.a.createElement("div", {
      className: "available-slots"
    }, y.a.isNil(h) ? i.a.createElement("div", {
      className: "available-dates"
    }, y.a.map(P, function (e) {
      var t = y.a.size(y.a.filter(y.a.values(y.a.get(u, "slots.".concat(e))), function (e) {
        var t = e.capacity;
        return !e.isPast && t >= 1;
      }));
      return i.a.createElement(x.Button, {
        key: e,
        className: "option-button",
        style: q,
        fullWidth: !0,
        onClick: function onClick() {
          C(ye()(e, "YYYY-MM-DD"));
        }
      }, i.a.createElement("div", {
        className: "button-label"
      }, i.a.createElement("span", {
        className: "day"
      }, ye()(e, "YYYY-MM-DD").format("ddd, MMM D, YYYY")), i.a.createElement("span", {
        className: "slot-count"
      }, t, " available")));
    })) : i.a.createElement("div", {
      className: "available-times"
    }, i.a.createElement("div", {
      className: "focused-date-header"
    }, i.a.createElement(x.IconButton, {
      onClick: function onClick() {
        C(null);
      }
    }, i.a.createElement(ve.a, null)), i.a.createElement("div", {
      className: "date"
    }, h.format("ddd, MMMM D, YYYY"))), i.a.createElement("div", {
      className: "time-buttons"
    }, y.a.map(y.a.keys(y.a.get(u, "slots.".concat(h.format("YYYY-MM-DD")))), function (e) {
      var n = y.a.get(u, "slots.".concat(h.format("YYYY-MM-DD"), ".").concat(e), {}),
          r = n.capacity;
      return n.isPast || r < 1 ? null : i.a.createElement(x.Button, {
        key: e,
        fullWidth: !0,
        className: "time-button",
        style: y.a.get(A, "time") !== e ? q : {
          background: a,
          color: s
        },
        onClick: function onClick() {
          m({
            date: h.format("YYYY-MM-DD"),
            time: e
          });
        }
      }, ye.a.tz(e, "HH:mm:ss", t.timezone).local().format("h:mm a"));
    })))))), i.a.createElement("div", {
      className: "bottom-bar"
    }, i.a.createElement(x.Button, {
      fullWidth: !0,
      variant: "contained",
      style: {
        backgroundColor: y.a.isNil(A) ? "#eee" : z(l, 1),
        color: y.a.isNil(A) ? null : c
      },
      disabled: y.a.isNil(A),
      onClick: function onClick() {
        w(!0), p(A).then(function (e) {
          w(!1), o("minimized");
        }).catch(function (e) {
          e.message.endsWith("409") ? (w(!1), m(null), "Reservation session is full" === y.a.get(e, "response.message") ? B(!0) : (I(!0), d(null))) : (w(!1), M(!0));
        });
      }
    }, "Schedule this appointment")), b ? i.a.createElement("div", {
      className: "scheduling-overlay"
    }, i.a.createElement(x.CircularProgress, {
      size: 50,
      className: "scheduling-progress",
      style: {
        color: a
      }
    })) : null, k ? i.a.createElement("div", {
      className: "scheduling-overlay"
    }, i.a.createElement("div", {
      className: "appointment-taken-message"
    }, i.a.createElement("div", {
      className: "main-line"
    }, i.a.createElement(ke.a, null), " Appointment time not available"), i.a.createElement("div", {
      className: "sub-line"
    }, i.a.createElement("div", null, "Looks like somebody booked that appointment time right before you clicked the schedule button."), i.a.createElement("div", null, "We have reloaded the latest available appointment slots, so please choose a different time for your appointment."), i.a.createElement(x.Button, {
      fullWidth: !0,
      variant: "outlined",
      onClick: function onClick() {
        return I(!1);
      }
    }, "Show latest available times")))) : null, j ? i.a.createElement("div", {
      className: "scheduling-overlay"
    }, i.a.createElement("div", {
      className: "appointment-taken-message"
    }, i.a.createElement("div", {
      className: "main-line"
    }, i.a.createElement(X.a, null), " Unable to schedule your appointment!"), i.a.createElement("div", {
      className: "sub-line"
    }, i.a.createElement("div", null, "We were unable to schedule the requested appointment.  Please make sure you are connected to the internet. If this issue continues, then you can call the pharmacy to schedule your appointment."), i.a.createElement(x.Button, {
      fullWidth: !0,
      variant: "outlined",
      onClick: function onClick() {
        return M(!1);
      }
    }, "OK")))) : null, N ? i.a.createElement("div", {
      className: "scheduling-overlay"
    }, i.a.createElement("div", {
      className: "session-full-message"
    }, i.a.createElement("div", {
      className: "main-line"
    }, i.a.createElement(X.a, null), " No more appointments are available right now."), i.a.createElement("div", {
      className: "sub-line"
    }, i.a.createElement("div", null, "The maximum number of allowed appointments at this time have already been scheduled. Please message the pharmacy to see when more appointments will be made available."), i.a.createElement(x.Button, {
      fullWidth: !0,
      variant: "outlined",
      onClick: function onClick() {
        B(!1), o("minimized");
      }
    }, "OK")))) : null);
  }

  function _e(e, t, n) {
    var r = ye.a.utc().add(n, "minutes");
    y.a.forIn(y.a.get(e, "slots"), function (e, n) {
      y.a.forIn(e, function (e, i) {
        e.isPast = r.isAfter(ye.a.tz("".concat(n, " ").concat(i), "YYYY-MM-DD HH:mm:ss", t));
      });
    });
  }

  n(59);

  function Fe(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var n = [],
          r = !0,
          i = !1,
          o = void 0;

      try {
        for (var a, s = e[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
          ;
        }
      } catch (e) {
        i = !0, o = e;
      } finally {
        try {
          r || null == s.return || s.return();
        } finally {
          if (i) throw o;
        }
      }

      return n;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return De(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === n && e.constructor && (n = e.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(e);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return De(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function De(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }

    return r;
  }

  function Re(e) {
    var t = e.label,
        n = e.savingLabel,
        o = e.savedLabel,
        a = e.onSave,
        s = e.afterSaveMessage,
        l = e.afterErrorMessage,
        c = e.isInitiallySaved,
        u = void 0 !== c && c,
        A = e.primaryColor,
        m = void 0 === A ? " #00B18F" : A,
        p = Fe(Object(r.useState)(u), 2),
        f = p[0],
        d = p[1],
        g = Fe(Object(r.useState)(null), 2),
        h = g[0],
        C = g[1],
        v = Fe(Object(r.useState)(!1), 2),
        b = v[0],
        y = v[1];
    Object(r.useMemo)(function () {
      return P(m, ["#ffffff", "#000000"]);
    }, [m]);
    return i.a.createElement("span", {
      className: "saving-button"
    }, i.a.createElement(x.Button, {
      fullWidth: !0,
      style: {
        backgroundColor: z(m, .2),
        color: "#000"
      },
      disabled: b || f,
      onClick: function onClick() {
        C(null), y(!0), a().then(function () {
          d(!0), y(!1);
        }).catch(function (e) {
          y(!1), C(e);
        });
      }
    }, f ? o : b ? i.a.createElement("div", {
      style: {
        display: "flex",
        alignItems: "center"
      }
    }, i.a.createElement(x.CircularProgress, {
      size: 20,
      style: {
        color: m
      }
    }), " ", n) : t), !f || _.isNil(s) ? null : i.a.createElement("div", {
      className: "after-saving-message"
    }, s), _.isNil(h) ? null : i.a.createElement("div", {
      className: "after-error-message"
    }, i.a.createElement(X.a, null), i.a.createElement("div", {
      className: "text"
    }, l)));
  }

  function Te() {
    return (Te = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function Ye(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var n = [],
          r = !0,
          i = !1,
          o = void 0;

      try {
        for (var a, s = e[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
          ;
        }
      } catch (e) {
        i = !0, o = e;
      } finally {
        try {
          r || null == s.return || s.return();
        } finally {
          if (i) throw o;
        }
      }

      return n;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return Je(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === n && e.constructor && (n = e.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(e);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Je(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function Je(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }

    return r;
  }

  function Ue(e) {
    var t = e.primaryFgColor,
        n = e.getPreviouslySaidNotInterested,
        o = e.onOpenScheduler,
        a = arguments[0],
        s = Object(r.useState)("minimized"),
        l = Ye(s, 2),
        c = l[0],
        u = l[1],
        A = Object(r.useState)(n()),
        m = Ye(A, 2),
        p = m[0],
        f = m[1],
        d = Object(r.useState)(!1),
        g = Ye(d, 2),
        h = g[0],
        C = g[1],
        v = Object(r.useState)(null),
        b = Ye(v, 2),
        y = b[0],
        x = b[1];
    return "minimized" === c ? i.a.createElement(ze, Te({}, a, {
      setView: function setView(e) {
        "maximized" === e ? o() : u(e);
      },
      getAreAllSlotsFull: function getAreAllSlotsFull() {
        return !1;
      },
      notInterested: p,
      setNotInterested: f,
      sendingNotInterested: h,
      setSendingNotInterested: C,
      answerToIsInterested: y,
      setAnswerToIsInterested: x,
      primaryFgColor: t,
      isThirdPartyScheduler: !0
    })) : "not-interested" === c ? i.a.createElement("div", {
      className: "appointment-scheduler-fullscreen-wrapper"
    }, i.a.createElement(Pe, Te({}, a, {
      setView: u,
      setNotInterested: f
    }))) : void 0;
  }
}]));